webpackJsonp([62],{

/***/ 1002:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 403, 404, 500];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });

        if (resStatusError.includes(res.status)) {
            res.json().then(function (json) {
                return reject(_extends({ statusText: res.statusText }, json));
            });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();

            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(334);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(44);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            var isCORE = entry.types[0].startsWith("CORE");
            if (isCORE) {
                var token = Object(lib["j" /* getAccessToken */])();

                if (!token) return next(action);

                var _getAllToken = Object(lib["k" /* getAllToken */])(),
                    expired_on = _getAllToken.expired_on;

                var currentTime = moment_timezone_default()().format(lib["i" /* dateTimeFormat */]);
                var duration = moment_timezone_default.a.duration(moment_timezone_default()(expired_on).diff(currentTime));
                var minutes = duration.asMinutes();
                if (minutes <= 5) {
                    Object(lib["h" /* clearToken */])();
                    window.location.replace("/");
                    // console.info('request new token')

                    // fetch(`${CORE_API_ENDPOINT}/user/refeshtoken`, {
                    //     method: 'POST',
                    //     headers: {
                    //         'Content-Type': 'application/json'
                    //     },
                    //     body: JSON.stringify({ access_token })
                    // })
                    //     .then(res => res.json())
                    //     .then(json => setToken(json))
                    //     .then(() => next(action))
                } else {
                    next(action);
                }
            } else {
                next(action);
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var setToken__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



// import types from '../types'
/* harmony default export */ var setToken = (function (store) {
	return function (next) {
		return function (action) {

			var entry = action[CALL_API];
			// const ignorTypes  = [types.]
			if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

			var token = void 0;
			var entryType = entry.types[0];

			if (entryType.startsWith("CORE")) {
				token = Object(lib["j" /* getAccessToken */])();
			}
			// else if(entry.types[0].startsWith("O365")){ 
			//   token = getAccessToken()
			// }

			if (!token) return next(action);

			entry.headers = setToken__extends({}, entry.headers);
			if (token) {
				entry.headers.Authorization = 'Bearer ' + token;
			}

			next(action);
		};
	};
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedInO365;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserInfo;
/* unused harmony export getUserEmail */
/* harmony export (immutable) */ __webpack_exports__["c"] = getSettings;
function getIsLoggedIn(state) {
    return !!state.auth.bsrsToken;
}

function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token;
}

function getUserInfo(state) {
    return state.auth.user;
}

function getUserEmail(state) {
    return state.auth.user.email;
}

function getSettings(state, props) {
    return state.settings;
}

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getAccessToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = getBackupAccessToken;
/* harmony export (immutable) */ __webpack_exports__["h"] = getIsActive;
/* unused harmony export getIsExecutive */
/* harmony export (immutable) */ __webpack_exports__["e"] = getAllToken;
/* unused harmony export getAmenityToken */
/* harmony export (immutable) */ __webpack_exports__["p"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["n"] = setCookieSetting;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMinStep;
/* unused harmony export getUserInfo */
/* harmony export (immutable) */ __webpack_exports__["o"] = setIsAgree;
/* unused harmony export getBSRSToken */
/* harmony export (immutable) */ __webpack_exports__["k"] = getfullName;
/* harmony export (immutable) */ __webpack_exports__["j"] = getUserId;
/* harmony export (immutable) */ __webpack_exports__["m"] = setBSRSToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearBSRSToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearBackupAccessToken;
/* harmony export (immutable) */ __webpack_exports__["l"] = setAmenityserviceFloor;
/* harmony export (immutable) */ __webpack_exports__["f"] = getAmenityserviceFloor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonwebtoken__);



var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var BACKUP_ACCESS_TOKEN = 'backup_access_token';
var EXPIRES_ON = 'expires_on';
var USER_EMAIL = 'user_email';
var USER_ID = 'user_id';
var IS_AGREE = 'isAgreeTermAndCondition';
var FULL_NAME = 'fullName';
var EMP_ID = 'employeeId';
var ROLE = 'role';
var IS_EXECUTIVE = 'isExecutive';
var AMENITY = 'AmenityPage';
var IS_ACTIVE = 'isActive';
var AMENITYSERVICE_FLOOR = 'AMENITYSERVICE_FLOOR';
var MIN_STEP = "min_step";

function getCookie(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(key);
}

function setCookie(key, value) {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(key, value);
}

function removeCookie(key) {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(key);
}

function getAccessToken() {
    return getCookie(ACCESS_TOKEN);
}
function getBackupAccessToken() {
    return getCookie(BACKUP_ACCESS_TOKEN);
}
function getIsActive() {
    return getCookie(IS_ACTIVE) === 'true';
}

function getIsExecutive() {
    return getCookie(IS_EXECUTIVE) === 'true';
}

function getAllToken() {

    if (!getCookie(ACCESS_TOKEN)) return {};
    return {
        access_token: getCookie(ACCESS_TOKEN),
        user_email: getCookie(USER_EMAIL),
        user_id: getCookie(USER_ID),
        expired_on: getCookie(EXPIRES_ON),
        isAgreeTermAndCondition: getCookie(IS_AGREE),
        fullName: getCookie(FULL_NAME),
        employeeId: getCookie(EMP_ID),
        role: getCookie(ROLE),
        isExecutive: getCookie(IS_EXECUTIVE)
    };
}

function getAmenityToken() {
    return {
        amenity: getCookie(AMENITY)
    };
}

function setToken(props) {
    clearBSRSToken();
    var token = props.token,
        email = props.email,
        userId = props.userId,
        expires_date_on = props.expires_date_on,
        isAgreeTermAndCondition = props.isAgreeTermAndCondition,
        employeeId = props.employeeId,
        fullName = props.fullName,
        role = props.role,
        isExecutive = props.isExecutive,
        isActive = props.isActive;

    if (typeof token !== "undefined") setCookie(ACCESS_TOKEN, token);
    if (typeof token !== "undefined") setCookie(BACKUP_ACCESS_TOKEN, token);
    if (typeof email !== "undefined") setCookie(USER_EMAIL, email);
    if (typeof userId !== "undefined") setCookie(USER_ID, userId);
    if (typeof expires_date_on !== "undefined") setCookie(EXPIRES_ON, expires_date_on);
    if (typeof isAgreeTermAndCondition !== "undefined") setCookie(IS_AGREE, isAgreeTermAndCondition);
    if (typeof fullName !== "undefined") setCookie(FULL_NAME, fullName);
    if (typeof employeeId !== "undefined") setCookie(EMP_ID, employeeId);
    if (typeof role !== "undefined") setCookie(ROLE, role);
    if (typeof isExecutive !== "undefined") setCookie(IS_EXECUTIVE, isExecutive);
    setCookie(IS_ACTIVE, isActive);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(USER_EMAIL);
    removeCookie(USER_ID);
    removeCookie(IS_AGREE);
    removeCookie(FULL_NAME);
    removeCookie(EMP_ID);
    removeCookie(ROLE);
    removeCookie(IS_EXECUTIVE);
    removeCookie(IS_ACTIVE);
}

function setCookieSetting(setting) {
    if (!!setting) {
        if (!isNaN(parseInt(setting.slotDuration, 0))) {
            setCookie(MIN_STEP, parseInt(setting.slotDuration, 0));
        }
    }
}

function getMinStep() {
    var minStep = parseInt(getCookie(MIN_STEP), 10);
    if (!isNaN(minStep) && getCookie(MIN_STEP) > 0) {
        return minStep;
    } else {
        return 30;
    }
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    var _jwt$decode = __WEBPACK_IMPORTED_MODULE_1_jsonwebtoken___default.a.decode(access_token),
        iat = _jwt$decode.iat,
        exp = _jwt$decode.exp,
        appid = _jwt$decode.appid,
        name = _jwt$decode.name,
        email = _jwt$decode.unique_name;

    return {
        iat: iat,
        exp: exp,
        appid: appid,
        name: name,
        email: email
    };
}
function setIsAgree() {
    return setCookie(IS_AGREE, true);
}
function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}

function getfullName() {
    return getCookie(FULL_NAME);
}

function getUserId() {
    return getCookie(USER_ID);
}

function setBSRSToken(access_token) {
    setCookie(BSRS_ACCESS_TOKEN, access_token);
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(ACCESS_TOKEN);
    removeCookie(USER_EMAIL);
    removeCookie(USER_ID);
    removeCookie(EXPIRES_ON);
    removeCookie(IS_AGREE);
    removeCookie(FULL_NAME);
    removeCookie(EMP_ID);
    removeCookie(ROLE);
    removeCookie(IS_ACTIVE);
}

function clearBackupAccessToken() {
    removeCookie(BACKUP_ACCESS_TOKEN);
}

function setAmenityserviceFloor(value) {
    removeCookie(AMENITYSERVICE_FLOOR);
    setCookie(AMENITYSERVICE_FLOOR, value);
}

function getAmenityserviceFloor() {
    return getCookie(AMENITYSERVICE_FLOOR);
}

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_SEARCH_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_SEARCH_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_SEARCH_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_ROOMS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_LOAD_ROOMS_SUGGEST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_LOAD_ROOMS_SUGGEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_LOAD_ROOMS_SUGGEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_LOAD_SLOTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_LOAD_SLOTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_LOAD_SLOTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_LOAD_FLOORS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_LOAD_FLOORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_LOAD_FLOORS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_LOAD_FLOOR_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_LOAD_FLOOR_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_LOAD_FLOOR_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_LOAD_AMENITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_LOAD_AMENITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_LOAD_AMENITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_LOAD_ROOMINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_LOAD_ROOMINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_LOAD_ROOMINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return LOAD_ROOMINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return LOAD_ROOMINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return LOAD_ROOMINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_EDIT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_EDIT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_EDIT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_DELETE_EVENT_RECURRENCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_DELETE_EVENT_RECURRENCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_DELETE_EVENT_RECURRENCE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_LOAD_EVENTINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_LOAD_EVENTINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_LOAD_EVENTINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_LOAD_EVENTINCOMING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_LOAD_EVENTINCOMING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_LOAD_EVENTINCOMING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_LOAD_EVENTHISTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_LOAD_EVENTHISTORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_LOAD_EVENTHISTORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_VERIFY_BYPASS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_VERIFY_BYPASS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_VERIFY_BYPASS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_ACCEPT_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_ACCEPT_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_ACCEPT_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CHECKIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CHECKIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CHECKIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_LOAD_EVENTCALENDAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_LOAD_EVENTCALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_LOAD_EVENTCALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_LOAD_AMENITYACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_LOAD_AMENITYACTIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_LOAD_AMENITYACTIVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_LOAD_AMENITYPAST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_LOAD_AMENITYPAST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_LOAD_AMENITYPAST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_LOAD_AMENITYNEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_LOAD_AMENITYNEXT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_LOAD_AMENITYNEXT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_LOAD_FOODS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_LOAD_FOODS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_LOAD_FOODS_FAILURE; });
/* unused harmony export CORE_LOAD_SERVICEACTIVE_REQUEST */
/* unused harmony export CORE_LOAD_SERVICEACTIVE_SUCCESS */
/* unused harmony export CORE_LOAD_SERVICEACTIVE_FAILURE */
/* unused harmony export CORE_LOAD_SERVICEPAST_REQUEST */
/* unused harmony export CORE_LOAD_SERVICEPAST_SUCCESS */
/* unused harmony export CORE_LOAD_SERVICEPAST_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_DELETE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_DELETE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_DELETE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_SENDAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_SENDAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_SENDAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_SENDFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_SENDFOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_SENDFOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_LOAD_FOODACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_LOAD_FOODACTIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_LOAD_FOODACTIVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_LOAD_FOODPAST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_LOAD_FOODPAST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_LOAD_FOODPAST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_LOAD_FOODNEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_LOAD_FOODNEXT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_LOAD_FOODNEXT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_DONEAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_DONEAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_DONEAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_DONEFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_DONEFOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_DONEFOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_REOPEN_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_REOPEN_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_REOPEN_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_REOPEN_FOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_REOPEN_FOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_REOPEN_FOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_ORDER_LOG_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_ORDER_LOG_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_ORDER_LOG_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_ORDER_LOG_FOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_ORDER_LOG_FOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_ORDER_LOG_FOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CANCELEVENTAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CANCELEVENTAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CANCELEVENTAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CANCELEVENTFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CANCELEVENTFOOD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CANCELEVENTFOOD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CREATE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CREATE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_LOAD_ORDER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_LOAD_ORDER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_LOAD_ORDER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_EDIT_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_EDIT_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_EDIT_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_LOAD_LAST_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_LOAD_LAST_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_LOAD_LAST_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_LOAD_EVENT_LOG_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_LOAD_EVENT_LOG_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_LOAD_EVENT_LOG_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_EVENT_LOG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_EVENT_LOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_EVENT_LOG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_SCANQR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_SCANQR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_SCANQR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_LOAD_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_LOAD_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_LOAD_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_LOAD_EVENTSERVICEAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_LOAD_EVENTSERVICEAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_LOAD_EVENTSERVICEFBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_LOAD_EVENTSERVICEFBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_LOAD_EVENTSERVICEFBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_LOAD_ROOM_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_LOAD_ROOM_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_LOAD_ROOM_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_LOAD_EVENTINFOSERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_LOAD_EVENTINFOSERVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_LOAD_EVENTINFOSERVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_SAVE_FORMSUGGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_SAVE_FORMSEARCHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CLEAR_FORMSEARCHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_LOAD_SETTINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_LOAD_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_LOAD_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_VERIFY_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_VERIFY_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_VERIFY_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_SEND_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_SEND_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_SEND_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_FIRST_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_FIRST_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_FIRST_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CHECKCANBOOK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CHECKCANBOOK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CHECKCANBOOK_FAILURE; });
var LOGOUT = 'LOGOUT';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var CORE_SEARCH_ROOMS_REQUEST = 'CORE_SEARCH_ROOMS_REQUEST';
var CORE_SEARCH_ROOMS_SUCCESS = 'CORE_SEARCH_ROOMS_SUCCESS';
var CORE_SEARCH_ROOMS_FAILURE = 'CORE_SEARCH_ROOMS_FAILURE';
var CORE_ROOMS_CLEAR = 'CORE_ROOMS_CLEAR';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var CORE_LOAD_ROOMS_SUGGEST_REQUEST = 'CORE_LOAD_ROOMS_SUGGEST_REQUEST';
var CORE_LOAD_ROOMS_SUGGEST_SUCCESS = 'CORE_LOAD_ROOMS_SUGGEST_SUCCESS';
var CORE_LOAD_ROOMS_SUGGEST_FAILURE = 'CORE_LOAD_ROOMS_SUGGEST_FAILURE';

var CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST';
var CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS';
var CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE';

var CORE_LOAD_SLOTS_REQUEST = 'CORE_LOAD_SLOTS_REQUEST';
var CORE_LOAD_SLOTS_SUCCESS = 'CORE_LOAD_SLOTS_SUCCESS';
var CORE_LOAD_SLOTS_FAILURE = 'CORE_LOAD_SLOTS_FAILURE';

var CORE_LOAD_FLOORS_REQUEST = 'CORE_LOAD_FLOORS_REQUEST';
var CORE_LOAD_FLOORS_SUCCESS = 'CORE_LOAD_FLOORS_SUCCESS';
var CORE_LOAD_FLOORS_FAILURE = 'CORE_LOAD_FLOORS_FAILURE';

var CORE_LOAD_FLOOR_INFO_REQUEST = 'CORE_LOAD_FLOOR_INFO_REQUEST';
var CORE_LOAD_FLOOR_INFO_SUCCESS = 'CORE_LOAD_FLOOR_INFO_SUCCESS';
var CORE_LOAD_FLOOR_INFO_FAILURE = 'CORE_LOAD_FLOOR_INFO_FAILURE';

var CORE_LOAD_AMENITIES_REQUEST = 'CORE_LOAD_AMENITIES_REQUEST';
var CORE_LOAD_AMENITIES_SUCCESS = 'CORE_LOAD_AMENITIES_SUCCESS';
var CORE_LOAD_AMENITIES_FAILURE = 'CORE_LOAD_AMENITIES_FAILURE';

var CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST';
var CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS';
var CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE';

var CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST';
var CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS';
var CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE';

var CORE_LOAD_ROOMINFO_REQUEST = 'CORE_LOAD_ROOMINFO_REQUEST';
var CORE_LOAD_ROOMINFO_SUCCESS = 'CORE_LOAD_ROOMINFO_SUCCESS';
var CORE_LOAD_ROOMINFO_FAILURE = 'CORE_LOAD_ROOMINFO_FAILURE';

var LOAD_ROOMINFO_REQUEST = 'LOAD_ROOMINFO_REQUEST';
var LOAD_ROOMINFO_SUCCESS = 'LOAD_ROOMINFO_SUCCESS';
var LOAD_ROOMINFO_FAILURE = 'LOAD_ROOMINFO_FAILURE';

var CORE_CREATE_EVENT_REQUEST = 'CORE_CREATE_EVENT_REQUEST';
var CORE_CREATE_EVENT_SUCCESS = 'CORE_CREATE_EVENT_SUCCESS';
var CORE_CREATE_EVENT_FAILURE = 'CORE_CREATE_EVENT_FAILURE';

var CORE_EDIT_EVENT_REQUEST = 'CORE_EDIT_EVENT_REQUEST';
var CORE_EDIT_EVENT_SUCCESS = 'CORE_EDIT_EVENT_SUCCESS';
var CORE_EDIT_EVENT_FAILURE = 'CORE_EDIT_EVENT_FAILURE';

var CORE_DELETE_EVENT_REQUEST = 'CORE_DELETE_EVENT_REQUEST';
var CORE_DELETE_EVENT_SUCCESS = 'CORE_DELETE_EVENT_SUCCESS';
var CORE_DELETE_EVENT_FAILURE = 'CORE_DELETE_EVENT_FAILURE';

var CORE_DELETE_EVENT_RECURRENCE_REQUEST = 'CORE_DELETE_EVENT_RECURRENCE_REQUEST';
var CORE_DELETE_EVENT_RECURRENCE_SUCCESS = 'CORE_DELETE_EVENT_RECURRENCE_SUCCESS';
var CORE_DELETE_EVENT_RECURRENCE_FAILURE = 'CORE_DELETE_EVENT_RECURRENCE_FAILURE';

var CORE_LOAD_EVENTINFO_REQUEST = 'CORE_LOAD_EVENTINFO_REQUEST';
var CORE_LOAD_EVENTINFO_SUCCESS = 'CORE_LOAD_EVENTINFO_SUCCESS';
var CORE_LOAD_EVENTINFO_FAILURE = 'CORE_LOAD_EVENTINFO_FAILURE';

var CORE_LOAD_EVENTINCOMING_REQUEST = 'CORE_LOAD_EVENTINCOMING_REQUEST';
var CORE_LOAD_EVENTINCOMING_SUCCESS = 'CORE_LOAD_EVENTINCOMING_SUCCESS';
var CORE_LOAD_EVENTINCOMING_FAILURE = 'CORE_LOAD_EVENTINCOMING_FAILURE';

var CORE_LOAD_EVENTHISTORY_REQUEST = 'CORE_LOAD_EVENTHISTORY_REQUEST';
var CORE_LOAD_EVENTHISTORY_SUCCESS = 'CORE_LOAD_EVENTHISTORY_SUCCESS';
var CORE_LOAD_EVENTHISTORY_FAILURE = 'CORE_LOAD_EVENTHISTORY_FAILURE';

var CORE_VERIFY_BYPASS_REQUEST = 'CORE_VERIFY_BYPASS_REQUEST';
var CORE_VERIFY_BYPASS_SUCCESS = 'CORE_VERIFY_BYPASS_SUCCESS';
var CORE_VERIFY_BYPASS_FAILURE = 'CORE_VERIFY_BYPASS_FAILURE';

var CORE_ACCEPT_TERM_REQUEST = 'CORE_ACCEPT_TERM_REQUEST';
var CORE_ACCEPT_TERM_SUCCESS = 'CORE_ACCEPT_TERM_SUCCESS';
var CORE_ACCEPT_TERM_FAILURE = 'CORE_ACCEPT_TERM_FAILURE';

var CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST';
var CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS';
var CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE';

var CORE_LOAD_EVENTCALENDAR_REQUEST = 'CORE_LOAD_EVENTCALENDAR_REQUEST';
var CORE_LOAD_EVENTCALENDAR_SUCCESS = 'CORE_LOAD_EVENTCALENDAR_SUCCESS';
var CORE_LOAD_EVENTCALENDAR_FAILURE = 'CORE_LOAD_EVENTCALENDAR_FAILURE';

var CORE_LOAD_AMENITYACTIVE_REQUEST = 'CORE_LOAD_AMENITYACTIVE_REQUEST';
var CORE_LOAD_AMENITYACTIVE_SUCCESS = 'CORE_LOAD_AMENITYACTIVE_SUCCESS';
var CORE_LOAD_AMENITYACTIVE_FAILURE = 'CORE_LOAD_AMENITYACTIVE_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_AMENITYPAST_REQUEST = 'CORE_LOAD_AMENITYPAST_REQUEST';
var CORE_LOAD_AMENITYPAST_SUCCESS = 'CORE_LOAD_AMENITYPAST_SUCCESS';
var CORE_LOAD_AMENITYPAST_FAILURE = 'CORE_LOAD_AMENITYPAST_FAILURE';

var CORE_LOAD_AMENITYNEXT_REQUEST = 'CORE_LOAD_AMENITYNEXT_REQUEST';
var CORE_LOAD_AMENITYNEXT_SUCCESS = 'CORE_LOAD_AMENITYNEXT_SUCCESS';
var CORE_LOAD_AMENITYNEXT_FAILURE = 'CORE_LOAD_AMENITYNEXT_FAILURE';

var CORE_LOAD_FOODS_REQUEST = 'CORE_LOAD_FOODS_REQUEST';
var CORE_LOAD_FOODS_SUCCESS = 'CORE_LOAD_FOODS_SUCCESS';
var CORE_LOAD_FOODS_FAILURE = 'CORE_LOAD_FOODS_FAILURE';

var CORE_LOAD_SERVICEACTIVE_REQUEST = 'CORE_LOAD_SERVICEACTIVE_REQUEST';
var CORE_LOAD_SERVICEACTIVE_SUCCESS = 'CORE_LOAD_SERVICEACTIVE_SUCCESS';
var CORE_LOAD_SERVICEACTIVE_FAILURE = 'CORE_LOAD_SERVICEACTIVE_FAILURE';

var CORE_LOAD_SERVICEPAST_REQUEST = 'CORE_LOAD_SERVICEPAST_REQUEST';
var CORE_LOAD_SERVICEPAST_SUCCESS = 'CORE_LOAD_SERVICEPAST_SUCCESS';
var CORE_LOAD_SERVICEPAST_FAILURE = 'CORE_LOAD_SERVICEPAST_FAILURE';

var CORE_DELETE_ORDER_REQUEST = 'CORE_DELETE_ORDER_REQUEST';
var CORE_DELETE_ORDER_SUCCESS = 'CORE_DELETE_ORDER_SUCCESS';
var CORE_DELETE_ORDER_FAILURE = 'CORE_DELETE_ORDER_FAILURE';

var CORE_SENDAMENITY_REQUEST = 'CORE_SENDAMENITY_REQUEST';
var CORE_SENDAMENITY_SUCCESS = 'CORE_SENDAMENITY_SUCCESS';
var CORE_SENDAMENITY_FAILURE = 'CORE_SENDAMENITY_FAILURE';

var CORE_SENDFOOD_REQUEST = 'CORE_SENDFOOD_REQUEST';
var CORE_SENDFOOD_SUCCESS = 'CORE_SENDFOOD_SUCCESS';
var CORE_SENDFOOD_FAILURE = 'CORE_SENDFOOD_FAILURE';

var CORE_LOAD_FOODACTIVE_REQUEST = 'CORE_LOAD_FOODACTIVE_REQUEST';
var CORE_LOAD_FOODACTIVE_SUCCESS = 'CORE_LOAD_FOODACTIVE_SUCCESS';
var CORE_LOAD_FOODACTIVE_FAILURE = 'CORE_LOAD_FOODACTIVE_FAILURE';

var CORE_LOAD_FOODPAST_REQUEST = 'CORE_LOAD_FOODPAST_REQUEST';
var CORE_LOAD_FOODPAST_SUCCESS = 'CORE_LOAD_FOODPAST_SUCCESS';
var CORE_LOAD_FOODPAST_FAILURE = 'CORE_LOAD_FOODPAST_FAILURE';

var CORE_LOAD_FOODNEXT_REQUEST = 'CORE_LOAD_FOODNEXT_REQUEST';
var CORE_LOAD_FOODNEXT_SUCCESS = 'CORE_LOAD_FOODNEXT_SUCCESS';
var CORE_LOAD_FOODNEXT_FAILURE = 'CORE_LOAD_FOODNEXT_FAILURE';

var CORE_DONEAMENITY_REQUEST = 'CORE_DONEAMENITY_REQUEST';
var CORE_DONEAMENITY_SUCCESS = 'CORE_DONEAMENITY_SUCCESS';
var CORE_DONEAMENITY_FAILURE = 'CORE_DONEAMENITY_FAILURE';

var CORE_DONEFOOD_REQUEST = 'CORE_DONEFOOD_REQUEST';
var CORE_DONEFOOD_SUCCESS = 'CORE_DONEFOOD_SUCCESS';
var CORE_DONEFOOD_FAILURE = 'CORE_DONEFOOD_FAILURE';

var CORE_REOPEN_AMENITY_REQUEST = 'CORE_REOPEN_AMENITY_REQUEST';
var CORE_REOPEN_AMENITY_SUCCESS = 'CORE_REOPEN_AMENITY_SUCCESS';
var CORE_REOPEN_AMENITY_FAILURE = 'CORE_REOPEN_AMENITY_FAILURE';

var CORE_REOPEN_FOOD_REQUEST = 'CORE_REOPEN_FOOD_REQUEST';
var CORE_REOPEN_FOOD_SUCCESS = 'CORE_REOPEN_FOOD_SUCCESS';
var CORE_REOPEN_FOOD_FAILURE = 'CORE_REOPEN_FOOD_FAILURE';

var CORE_ORDER_LOG_AMENITY_REQUEST = 'CORE_ORDER_LOG_AMENITY_REQUEST';
var CORE_ORDER_LOG_AMENITY_SUCCESS = 'CORE_ORDER_LOG_AMENITY_SUCCESS';
var CORE_ORDER_LOG_AMENITY_FAILURE = 'CORE_ORDER_LOG_AMENITY_FAILURE';

var CORE_ORDER_LOG_FOOD_REQUEST = 'CORE_ORDER_LOG_FOOD_REQUEST';
var CORE_ORDER_LOG_FOOD_SUCCESS = 'CORE_ORDER_LOG_FOOD_SUCCESS';
var CORE_ORDER_LOG_FOOD_FAILURE = 'CORE_ORDER_LOG_FOOD_FAILURE';

var CORE_CANCELEVENTAMENITY_REQUEST = 'CORE_CANCELEVENTAMENITY_REQUEST';
var CORE_CANCELEVENTAMENITY_SUCCESS = 'CORE_CANCELEVENTAMENITY_SUCCESS';
var CORE_CANCELEVENTAMENITY_FAILURE = 'CORE_CANCELEVENTAMENITY_FAILURE';

var CORE_CANCELEVENTFOOD_REQUEST = 'CORE_CANCELEVENTFOOD_REQUEST';
var CORE_CANCELEVENTFOOD_SUCCESS = 'CORE_CANCELEVENTFOOD_SUCCESS';
var CORE_CANCELEVENTFOOD_FAILURE = 'CORE_CANCELEVENTFOOD_FAILURE';
var CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST';
var CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS';
var CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE';

var CORE_LOAD_ORDER_INFO_REQUEST = 'CORE_LOAD_ORDER_INFO_REQUEST';
var CORE_LOAD_ORDER_INFO_SUCCESS = 'CORE_LOAD_ORDER_INFO_SUCCESS';
var CORE_LOAD_ORDER_INFO_FAILURE = 'CORE_LOAD_ORDER_INFO_FAILURE';

var CORE_EDIT_ORDER_REQUEST = 'CORE_EDIT_ORDER_REQUEST';
var CORE_EDIT_ORDER_SUCCESS = 'CORE_EDIT_ORDER_SUCCESS';
var CORE_EDIT_ORDER_FAILURE = 'CORE_EDIT_ORDER_FAILURE';

var CORE_LOAD_LAST_USERS_REQUEST = 'CORE_LOAD_LAST_USERS_REQUEST';
var CORE_LOAD_LAST_USERS_SUCCESS = 'CORE_LOAD_LAST_USERS_SUCCESS';
var CORE_LOAD_LAST_USERS_FAILURE = 'CORE_LOAD_LAST_USERS_FAILURE';

var CORE_LOAD_EVENT_LOG_TITLE_REQUEST = 'CORE_LOAD_EVENT_LOG_TITLE_REQUEST';
var CORE_LOAD_EVENT_LOG_TITLE_SUCCESS = 'CORE_LOAD_EVENT_LOG_TITLE_SUCCESS';
var CORE_LOAD_EVENT_LOG_TITLE_FAILURE = 'CORE_LOAD_EVENT_LOG_TITLE_FAILURE';

var CORE_CREATE_EVENT_LOG_REQUEST = 'CORE_CREATE_EVENT_LOG_REQUEST';
var CORE_CREATE_EVENT_LOG_SUCCESS = 'CORE_CREATE_EVENT_LOG_SUCCESS';
var CORE_CREATE_EVENT_LOG_FAILURE = 'CORE_CREATE_EVENT_LOG_FAILURE';

var CORE_SCANQR_REQUEST = 'CORE_SCANQR_REQUEST';
var CORE_SCANQR_SUCCESS = 'CORE_SCANQR_SUCCESS';
var CORE_SCANQR_FAILURE = 'CORE_SCANQR_FAILURE';

var CORE_LOAD_ROOM_FORMAT_REQUEST = 'CORE_LOAD_ROOM_FORMAT_REQUEST';
var CORE_LOAD_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_ROOM_FORMAT_SUCCESS';
var CORE_LOAD_ROOM_FORMAT_FAILURE = 'CORE_LOAD_ROOM_FORMAT_FAILURE';

var CORE_LOAD_EVENTSERVICEAMENITY_REQUEST = 'CORE_LOAD_EVENTSERVICEAMENITY_REQUEST';
var CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS = 'CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS';
var CORE_LOAD_EVENTSERVICEAMENITY_FAILURE = 'CORE_LOAD_EVENTSERVICEAMENITY_FAILURE';

var CORE_LOAD_EVENTSERVICEFBS_REQUEST = 'LOAD_EVENTSERVICEFBS_REQUEST';
var CORE_LOAD_EVENTSERVICEFBS_SUCCESS = 'LOAD_EVENTSERVICEFBS_SUCCESS';
var CORE_LOAD_EVENTSERVICEFBS_FAILURE = 'LOAD_EVENTSERVICEFBS_FAILURE';

var CORE_LOAD_ROOM_TYPE_REQUEST = 'CORE_LOAD_ROOM_TYPE_REQUEST';
var CORE_LOAD_ROOM_TYPE_SUCCESS = 'CORE_LOAD_ROOM_TYPE_SUCCESS';
var CORE_LOAD_ROOM_TYPE_FAILURE = 'CORE_LOAD_ROOM_TYPE_FAILURE';

var CORE_LOAD_EVENTINFOSERVICE_REQUEST = 'CORE_LOAD_EVENTINFOSERVICE_REQUEST';
var CORE_LOAD_EVENTINFOSERVICE_SUCCESS = 'CORE_LOAD_EVENTINFOSERVICE_SUCCESS';
var CORE_LOAD_EVENTINFOSERVICE_FAILURE = 'CORE_LOAD_EVENTINFOSERVICE_FAILURE';

var CORE_SAVE_FORMSUGGEST = 'CORE_SAVE_FORMSUGGEST';
var CORE_SAVE_FORMSEARCHNAME = 'CORE_SAVE_FORMSEARCHNAME';
var CORE_CLEAR_FORMSEARCHNAME = 'CORE_CLEAR_FORMSEARCHNAME';

var CORE_LOAD_SETTINGS_REQUEST = 'CORE_LOAD_SETTINGS_REQUEST';
var CORE_LOAD_SETTINGS_SUCCESS = 'CORE_LOAD_SETTINGS_SUCCESS';
var CORE_LOAD_SETTINGS_FAILURE = 'CORE_LOAD_SETTINGS_FAILURE';

var CORE_VERIFY_LOGIN_REQUEST = 'CORE_VERIFY_LOGIN_REQUEST';
var CORE_VERIFY_LOGIN_SUCCESS = 'CORE_VERIFY_LOGIN_SUCCESS';
var CORE_VERIFY_LOGIN_FAILURE = 'CORE_VERIFY_LOGIN_FAILURE';

var CORE_SEND_REPORT_REQUEST = 'CORE_SEND_REPORT_REQUEST';
var CORE_SEND_REPORT_SUCCESS = 'CORE_SEND_REPORT_SUCCESS';
var CORE_SEND_REPORT_FAILURE = 'CORE_SEND_REPORT_FAILURE';

var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST';
var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS';
var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_FIRST_CHANGE_PASSWORD_REQUEST = 'CORE_FIRST_CHANGE_PASSWORD_REQUEST';
var CORE_FIRST_CHANGE_PASSWORD_SUCCESS = 'CORE_FIRST_CHANGE_PASSWORD_SUCCESS';
var CORE_FIRST_CHANGE_PASSWORD_FAILURE = 'CORE_FIRST_CHANGE_PASSWORD_FAILURE';

var CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST';
var CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS';
var CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE';

var CORE_CHECKCANBOOK_REQUEST = 'CORE_CHECKCANBOOK_REQUEST';
var CORE_CHECKCANBOOK_SUCCESS = 'CORE_CHECKCANBOOK_SUCCESS';
var CORE_CHECKCANBOOK_FAILURE = 'CORE_CHECKCANBOOK_FAILURE';

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoading;
/* harmony export (immutable) */ __webpack_exports__["a"] = getHasError;
/* unused harmony export getErrorMessage */
/* unused harmony export getErrorCode */
/* harmony export (immutable) */ __webpack_exports__["c"] = getUiMessage;
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getErrorMessage(state) {
    return state.ui.errorMessage;
}

function getErrorCode(state) {
    return state.ui.errorCode;
}

function getUiMessage(state) {
    return state.ui;
}

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = findRoomInfo;
/* harmony export (immutable) */ __webpack_exports__["f"] = findRoomInfoForAmenityAndService;
/* unused harmony export findSlot */
/* harmony export (immutable) */ __webpack_exports__["m"] = searchSuggest;
/* harmony export (immutable) */ __webpack_exports__["j"] = searchFirstSuggest;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearStateRooms;
/* harmony export (immutable) */ __webpack_exports__["k"] = searchRoom;
/* unused harmony export findAllRoom */
/* harmony export (immutable) */ __webpack_exports__["l"] = searchSlots;
/* harmony export (immutable) */ __webpack_exports__["d"] = findRoomFormat;
/* harmony export (immutable) */ __webpack_exports__["g"] = findRoomType;
/* harmony export (immutable) */ __webpack_exports__["i"] = saveFormSuggest;
/* harmony export (immutable) */ __webpack_exports__["h"] = saveFormSearchName;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearStateFormSearchName;
/* harmony export (immutable) */ __webpack_exports__["c"] = findDefaultSetting;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Middlewares__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Lib__ = __webpack_require__(44);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function findRoomInfo(id) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        // endpoint: `${CORE_API_ENDPOINT}/room/info/${id}`,
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/room/booking/info/' + id,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_70" /* CORE_LOAD_ROOMINFO_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_71" /* CORE_LOAD_ROOMINFO_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_69" /* CORE_LOAD_ROOMINFO_FAILURE */]]
    });
}

function findRoomInfoForAmenityAndService(id) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/room/info/' + id,
        // endpoint: `${CORE_API_ENDPOINT}/room/booking/info/${id}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_139" /* LOAD_ROOMINFO_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_140" /* LOAD_ROOMINFO_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_138" /* LOAD_ROOMINFO_FAILURE */]]
    });
}

function findSlot(history, id, date, start, end) {
    var yyyymmdd = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).format('YYYYMMDD');
    var urlEndPoint = __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/events/getslots/' + id + '/' + yyyymmdd;
    var historyUrl = '/roomSlots/' + id + '/' + yyyymmdd + '/' + start + '/' + end;
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: '' + urlEndPoint,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_91" /* CORE_LOAD_SLOTS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_92" /* CORE_LOAD_SLOTS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return [json.value];
                });
            },
            callBack: function callBack() {
                history.push(historyUrl);
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_90" /* CORE_LOAD_SLOTS_FAILURE */]]
    });
}

function searchSuggest(search) {
    var eventDate = '';
    if (search.search_date) {
        eventDate = new Date(search.search_date);
        eventDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(eventDate).format('YYYYMMDD');
    }
    var startTime = '';
    if (search.search_startDateTime) startTime = search.search_startDateTime;
    var endTime = '';
    if (search.search_endDateTime) endTime = search.search_endDateTime;

    var capacity = '';
    if (search.capacity && search.capacity !== '0') capacity = search.capacity;

    var floor = '';
    if (search.floorId && search.floorId !== '0') floor = search.floorId;

    var roomTypeId = '';
    if (search.roomtype !== '0') roomTypeId = search.roomtype;

    var amenities = '';
    if (search.amenities.length > 0) amenities = search.amenities.join(',');

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/rooms/suggest?floor=' + floor + '&date=' + eventDate + '&start=' + startTime + '&end=' + endTime + '&capacity=' + capacity + '&amenities=' + amenities + '&roomTypeId=' + roomTypeId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_79" /* CORE_LOAD_ROOMS_SUGGEST_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_80" /* CORE_LOAD_ROOMS_SUGGEST_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_78" /* CORE_LOAD_ROOMS_SUGGEST_FAILURE */]]
    });
}

function searchFirstSuggest() {

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/rooms/firstsuggest',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_74" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_75" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_73" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE */]]
    });
}

function clearStateRooms() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["_111" /* CORE_ROOMS_CLEAR */]
    };
}

function searchRoom(textSearch) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/rooms/search/' + textSearch,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_118" /* CORE_SEARCH_ROOMS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_119" /* CORE_SEARCH_ROOMS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return [json.value];
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_117" /* CORE_SEARCH_ROOMS_FAILURE */]]
    });
}

function findAllRoom() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/rooms/search/',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_76" /* CORE_LOAD_ROOMS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_77" /* CORE_LOAD_ROOMS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return [json.value];
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_72" /* CORE_LOAD_ROOMS_FAILURE */]]
    });
}

function searchSlots(date, roomId) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/events/getslots/' + roomId + '/' + date,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_91" /* CORE_LOAD_SLOTS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_92" /* CORE_LOAD_SLOTS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_90" /* CORE_LOAD_SLOTS_FAILURE */]]
    });
}

function findRoomFormat() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/roomformat/list',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_82" /* CORE_LOAD_ROOM_FORMAT_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_83" /* CORE_LOAD_ROOM_FORMAT_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_81" /* CORE_LOAD_ROOM_FORMAT_FAILURE */]]
    });
}

function findRoomType() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/roomType/list',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_85" /* CORE_LOAD_ROOM_TYPE_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_86" /* CORE_LOAD_ROOM_TYPE_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_84" /* CORE_LOAD_ROOM_TYPE_FAILURE */]]
    });
}

function saveFormSuggest(search) {

    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["_113" /* CORE_SAVE_FORMSUGGEST */],
        form: search
    };
}

function saveFormSearchName(search) {

    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["_112" /* CORE_SAVE_FORMSEARCHNAME */],
        form: search
    };
}

function clearStateFormSearchName() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["v" /* CORE_CLEAR_FORMSEARCHNAME */]
    };
}

function findDefaultSetting() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_3_Lib__["a" /* CORE_API_ENDPOINT */] + '/setting/info/',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_2__types__["_88" /* CORE_LOAD_SETTINGS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["_89" /* CORE_LOAD_SETTINGS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    if (!!json && !!json.value) {
                        Object(__WEBPACK_IMPORTED_MODULE_3_Lib__["t" /* setCookieSetting */])(json.value);
                    }
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_2__types__["_87" /* CORE_LOAD_SETTINGS_FAILURE */]]
    });
}

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUsers */
/* harmony export (immutable) */ __webpack_exports__["f"] = getUserInfo;
/* unused harmony export getAuthState */
/* harmony export (immutable) */ __webpack_exports__["c"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["a"] = getChangeSendMailResetPassword;
/* harmony export (immutable) */ __webpack_exports__["b"] = getHasSendReport;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSendEmail;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Lib__ = __webpack_require__(44);


function getUsers(state, props) {
    return state.users;
}

function getUserInfo(state, props) {
    return state.userInfo;
}

function getAuthState(state, props) {
    return state.auth;
}

function getIsLoggedIn(state) {
    var _getAllToken = Object(__WEBPACK_IMPORTED_MODULE_0_Lib__["k" /* getAllToken */])(),
        access_token = _getAllToken.access_token;

    return !!access_token;
}

function getChangeSendMailResetPassword(state) {
    return state.sendMailResetPassword;
}

function getHasSendReport(state) {
    return state.hasSendReport;
}

function getSendEmail(state) {
    return state.sendMail;
}

function getSettings(state, props) {
    return state.settings;
}

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Lib__ = __webpack_require__(44);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


// import CookiesManager from './CookiesManager'
// import { cookiesKey } from '../../../constant'


var MyManager = function () {
	function MyManager() {
		_classCallCheck(this, MyManager);

		this.requestMethod = {
			GET: "GET",
			POST: "POST",
			PATCH: "PATCH",
			DELETE: "DELETE"
		};
	}

	_createClass(MyManager, [{
		key: 'requestAction',
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options, callback) {
				var isHandleError, responseData, token, headers, res, response, status, data;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								isHandleError = true, responseData = {
									result: false,
									data: null,
									errors: []
								};
								_context.prev = 1;

								if (options) {
									_context.next = 4;
									break;
								}

								throw new Error("Invalid parameters");

							case 4:

								if ("isHandleError" in options && typeof options.isHandleError === "boolean") {
									isHandleError = options.isHandleError;
									delete options.isHandleError;
								}

								token = Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["j" /* getAccessToken */])();
								headers = options.headers;

								if (!headers) {
									headers = {
										'Content-Type': 'application/json'
									};
								} else {
									if (!headers["Content-Type"]) {
										headers['Content-Type'] = 'application/json';
									}
								}

								if (!!token && (options.useToken || !("useToken" in options))) {
									headers.Authorization = 'Bearer ' + token;
								}
								options.headers = headers;

								_context.next = 12;
								return __WEBPACK_IMPORTED_MODULE_0_axios___default()(options);

							case 12:
								res = _context.sent;


								if (!!res.data) {
									if ("value" in res.data) {
										responseData.result = true;
										responseData.data = res.data.value;
									} else if (!!res.data.code && !!res.data.message) {
										responseData.errors = [res.data];
									}
								}
								if (callback && typeof callback === "function") {
									callback(responseData);
								}

								return _context.abrupt('return', responseData);

							case 18:
								_context.prev = 18;
								_context.t0 = _context['catch'](1);
								response = _context.t0.response;

								responseData.result = false;
								if (!!response) {
									status = response.status, data = response.data;

									if (!!data && !!data.code && !!data.message) {
										responseData.errors = [data];
									} else {
										responseData.errors = [{
											code: status,
											message: "Something went wrong !"
										}];
									}
								}
								if (callback && typeof callback === "function") {
									callback(responseData);
								}

							case 24:
								return _context.abrupt('return', responseData);

							case 25:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[1, 18]]);
			}));

			function requestAction(_x, _x2) {
				return _ref.apply(this, arguments);
			}

			return requestAction;
		}()
	}]);

	return MyManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (MyManager);

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cookiesKey; });
/* unused harmony export defaultValue */


var cookiesKey = {
	IS_REMEMBER: "IS_REMEMBER",

	TOKEN: "TOKEN",
	REFRESH_TOKEN: "REFRESH_TOKEN",
	REFRESH_TOKEN_EXPIRES_DATE: "REFRESH_TOKEN_EXPIRES_DATE",
	TOKEN_EXPIRES_DATE: "TOKEN_EXPIRES_DATE",
	TOKEN_EXPIRES_ON: "TOKEN_EXPIRES_ON",

	USER_ID: "USER_ID",
	USER_FULL_NAME: "USER_FULL_NAME",
	USER_ROLE_NAME: "USER_ROLE_NAME"
};

var defaultValue = {
	PLEASE_SELECT: "PLEASE_SELECT",
	SELECT_ALL: "SELECT_ALL",
	NONE_SELECT: "NONE_SELECT"
};



/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js
// export const CORE_API_ENDPOINT = 'http://localhost:2701'
// export const CORE_API_ENDPOINT = `https://dtacbainisys.com/core`
var CORE_API_ENDPOINT = '/api';
// export const CORE_API_ENDPOINT = `https://dtacuat-front.rmbainisys.com/api`
// export const CORE_API_ENDPOINT = `https://aji-meetingroom.bainisyspro.com/api`

var O365_API_ENDPOINT = 'http://localhost:3000/o365';
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(261);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
var LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm';
var ShortDateTimeFormat = 'D MMM YYYY HH:mm';
var LongDateFormat = 'ddd MMM D, YYYY';
var ShortDateFormat = 'D MMM YYYY';
var timeFormat = 'HH:mm';
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var react_router_dom_es = __webpack_require__(71);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(79);

// EXTERNAL MODULE: ./src/features/user/selectors.js
var selectors = __webpack_require__(335);

// CONCATENATED MODULE: ./src/lib/withAuthCheck.js






var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return {
      isLoggedIn: Object(selectors["c" /* getIsLoggedIn */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// EXTERNAL MODULE: ./src/features/auth/selectors.js
var auth_selectors = __webpack_require__(232);

// CONCATENATED MODULE: ./src/lib/withAuthCheckO365.js






var withAuthCheckO365_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/logino365' });
};
var withAuthCheckO365_withAuthCheckO365 = function withAuthCheckO365(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheckO365 = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheckO365'), Object(es["connect"])(function (state) {
    return {
      isLoggedInO365: Object(auth_selectors["b" /* getIsLoggedInO365 */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedInO365 = _ref.isLoggedInO365;
    return isLoggedInO365;
  }, withAuthCheckO365_withAuthCheckO365, Object(Recompose["d" /* renderComponent */])(withAuthCheckO365_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withO365UserInfo.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var withO365UserInfo_withO365UserInfo = function withO365UserInfo(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, _extends({}, props, { O365UserInfo: props.userInfo }));
  };
};

/* harmony default export */ var lib_withO365UserInfo = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withO365UserInfo'), Object(es["connect"])(function (state) {
    return {
      userInfo: Object(auth_selectors["d" /* getUserInfo */])(state)
    };
  }), withO365UserInfo_withO365UserInfo)(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return O365_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return auth["d" /* getAccessToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return auth["g" /* getBackupAccessToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return auth["h" /* getIsActive */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return auth["e" /* getAllToken */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return auth["p" /* setToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return auth["c" /* clearToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return auth["n" /* setCookieSetting */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return auth["i" /* getMinStep */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return auth["o" /* setIsAgree */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return auth["k" /* getfullName */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return auth["j" /* getUserId */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return auth["m" /* setBSRSToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return auth["a" /* clearBSRSToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return auth["b" /* clearBackupAccessToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return auth["l" /* setAmenityserviceFloor */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return auth["f" /* getAmenityserviceFloor */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return dateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return LongDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return ShortDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return LongDateFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return ShortDateFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return timeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return lib_withAuthCheck; });
/* unused concated harmony import withAuthCheckO365 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheckO365; });
/* unused concated harmony import withO365UserInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withO365UserInfo; });







/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Features_ui_selectors__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(71);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ErrorMessage = function (_Component) {
  _inherits(ErrorMessage, _Component);

  function ErrorMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ErrorMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.show = function (dimmer) {
      return function () {
        return _this.setState({ dimmer: dimmer, open: true });
      };
    }, _this.close = function () {
      _this.setState({ open: false });
      // if (this.props.location.pathname === '/login')
      //   window.location.reload()
      if (_this.props.match.url === '/login') window.location.reload();
      if (_this.props.location.pathname.indexOf("undefined") !== -1) {
        window.location.replace("/");
      } else {
        _this.props.history.go(-1);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ErrorMessage, [{
    key: 'render',
    value: function render() {
      var dimmer = this.state.dimmer;
      var _props$uiError = this.props.uiError,
          errorCode = _props$uiError.errorCode,
          errorMessage = _props$uiError.errorMessage;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Modal */],
          { open: this.state.open, dimmer: dimmer, onClose: this.close },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Modal */].Header,
            null,
            'Something went wrong !'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Modal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Modal */].Description,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Error Code : ',
                errorCode
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Error Message : ',
                errorMessage
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Modal */].Actions,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Button */], {
              positive: true,
              icon: 'checkmark',
              labelPosition: 'right',
              content: 'OK',
              onClick: this.close
            })
          )
        )
      );
    }
  }]);

  return ErrorMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["f" /* withRouter */], Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, props) {
  return {
    uiError: Object(__WEBPACK_IMPORTED_MODULE_2_Features_ui_selectors__["c" /* getUiMessage */])(state)
  };
}))(ErrorMessage);

/* harmony default export */ __webpack_exports__["a"] = (ErrorMessage);

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(119);



/* harmony default export */ __webpack_exports__["a"] = (function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["d" /* Dimmer */],
        { active: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Loader */],
            { size: 'large' },
            'Loading'
        )
    );
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_auth__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rooms_actions__ = __webpack_require__(333);








var AuthFooter = function AuthFooter(props) {

	var home = function home() {
		// props.clearStateFormSearchName()
		window.location.replace('/');
	};

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Container */],
		null,
		Object(__WEBPACK_IMPORTED_MODULE_5__lib_auth__["e" /* getAllToken */])().access_token !== undefined && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["p" /* Menu */],
			{ size: 'mini', widths: 3, fluid: true, borderless: true, icon: 'labeled', fixed: 'bottom',
				style: { backgroundColor: '#010101', color: '#E0E0E0', height: '55px', textAlign: 'center', zIndex: '2' } },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["p" /* Menu */].Item,
				{ name: 'video camera'
					// as={Link} to='/'
					, onClick: function onClick() {
						return home();
					},
					style: { padding: '5px', fontSize: '1.5em' } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["k" /* Image */], { src: '/assets/images/icon_room.png', style: { width: 'auto', height: '45px' } })
			),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["p" /* Menu */].Item,
				{ name: 'content', as: __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], to: '/myreservationcoming', style: { padding: '5px', fontSize: '1.5em' } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["k" /* Image */], { src: '/assets/images/icon_meeting.png', style: { width: 'auto', height: '45px' } })
			),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["p" /* Menu */].Item,
				{ name: 'qrcode', as: __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], to: '/qrcode', style: { padding: '5px', fontSize: '1.5em' } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["k" /* Image */], { src: '/assets/images/icon_QR.png', style: { width: 'auto', height: '45px' } })
			)
		)
	);
};

// export default AuthFooter

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */], Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
	return {};
}, function (dispatch, props) {
	return {
		clearStateFormSearchName: function clearStateFormSearchName() {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__rooms_actions__["a" /* clearStateFormSearchName */])());
		}
	};
}))(AuthFooter));

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Loading = function Loading() {
    return (
        // <div>Loading...</div>
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRooms */
/* harmony export (immutable) */ __webpack_exports__["e"] = getRoom;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSettings;
/* harmony export (immutable) */ __webpack_exports__["i"] = getRoomsSuggest;
/* harmony export (immutable) */ __webpack_exports__["h"] = getRoomsFirstSuggest;
/* harmony export (immutable) */ __webpack_exports__["k"] = getSlots;
/* harmony export (immutable) */ __webpack_exports__["b"] = getFloors;
/* harmony export (immutable) */ __webpack_exports__["f"] = getRoomInfo;
/* unused harmony export getform */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAmenities;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRoomType;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFormSuggest;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFormSearchName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var getRooms = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
    return state.rooms;
}, function (rooms) {
    return rooms;
});

function getRoom(state, props) {
    return state.rooms;
}
function getSettings(state, props) {
    return state.settings;
}
function getRoomsSuggest(state, props) {
    return state.roomssuggest;
}

function getRoomsFirstSuggest(state, props) {
    return state.roomsfirstsuggest;
}

function getSlots(state, props) {
    return state.slots;
}

function getFloors(state, props) {
    return state.floors;
}

function getRoomInfo(state, props) {
    return state.roomInfo;
}

function getform(state, props) {
    return state.form.searchSlots ? state.form.searchSlots.values : [];
}

function getAmenities(state, props) {
    return state.amenities;
}

function getRoomType(state, props) {
    return state.roomType;
}

function getFormSuggest(state, props) {
    return state.formSuggest;
}

function getFormSearchName(state, props) {
    return state.formSearchName;
}

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = findLastUsers;
/* harmony export (immutable) */ __webpack_exports__["b"] = changePassword;
/* harmony export (immutable) */ __webpack_exports__["h"] = requestChangePassword;
/* harmony export (immutable) */ __webpack_exports__["d"] = finduserInfo;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadVerifyBypass;
/* harmony export (immutable) */ __webpack_exports__["g"] = loadVerifyLogin;
/* harmony export (immutable) */ __webpack_exports__["a"] = acceptTerm;
/* harmony export (immutable) */ __webpack_exports__["j"] = sendReport;
/* harmony export (immutable) */ __webpack_exports__["e"] = firstChangePassword;
/* harmony export (immutable) */ __webpack_exports__["i"] = sendEmailVerifyCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Middlewares__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Lib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_64__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_64__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function findLastUsers() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/lastattendees',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_61" /* CORE_LOAD_LAST_USERS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_62" /* CORE_LOAD_LAST_USERS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return [json.value];
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_60" /* CORE_LOAD_LAST_USERS_FAILURE */]]
    });
}

function changePassword(state, text, history) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/forgot/changepass/' + text,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: state.password, confirmPassword: state.password, code: state.code }),
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["n" /* CORE_CHANGE_PASSWORD_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["o" /* CORE_CHANGE_PASSWORD_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            },
            callBack: function callBack() {
                // window.location.replace('/login')
                history.push('/login');
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["m" /* CORE_CHANGE_PASSWORD_FAILURE */]]
    });
}

function requestChangePassword(email) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/resetpassword/' + email,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_127" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_128" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_126" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE */]]
    });
}
function finduserInfo() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/info/' + Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["k" /* getAllToken */])().user_id,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_97" /* CORE_LOAD_USER_INFO_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_98" /* CORE_LOAD_USER_INFO_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_96" /* CORE_LOAD_USER_INFO_FAILURE */]]
    });
}

function loadVerifyBypass(id, email) {
    var decodeEmail = __WEBPACK_IMPORTED_MODULE_3_base_64___default.a.decode(email);
    var data = {
        "id": id,
        "email": decodeEmail
    };
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/bypassverify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_133" /* CORE_VERIFY_BYPASS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_134" /* CORE_VERIFY_BYPASS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var _json$value = json.value,
                        token = _json$value.token,
                        expires_date_on = _json$value.expires_date_on,
                        isAgreeTermAndCondition = _json$value.isAgreeTermAndCondition,
                        data = _json$value.data,
                        role = _json$value.role;
                    var fullName = data.fullName,
                        userId = data.userId,
                        email = data.email,
                        employeeId = data.employeeId,
                        isExecutive = data.isExecutive,
                        isActive = data.isActive;

                    var tokens = {
                        token: token,
                        email: email,
                        userId: userId,
                        expires_date_on: expires_date_on,
                        isAgreeTermAndCondition: isAgreeTermAndCondition,
                        employeeId: employeeId,
                        fullName: fullName,
                        role: role,
                        isExecutive: isExecutive,
                        isActive: isActive
                    };

                    Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["v" /* setToken */])(tokens);
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_132" /* CORE_VERIFY_BYPASS_FAILURE */]]
    });
}

function loadVerifyLogin(email, password, history) {
    var data = {
        "email": email,
        "password": password
    };
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/verify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_136" /* CORE_VERIFY_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_137" /* CORE_VERIFY_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var _json$value2 = json.value,
                        token = _json$value2.token,
                        expires_date_on = _json$value2.expires_date_on,
                        data = _json$value2.data;
                    var fullName = data.fullName,
                        role = data.role,
                        userId = data.userId,
                        email = data.email,
                        isExecutive = data.isExecutive,
                        isAgreeTermAndCondition = data.isAgreeTermAndCondition,
                        isActive = data.isActive;

                    var tokens = {
                        token: token,
                        email: email,
                        userId: userId,
                        expires_date_on: expires_date_on,
                        isAgreeTermAndCondition: isAgreeTermAndCondition,
                        fullName: fullName,
                        role: role,
                        isExecutive: isExecutive,
                        isActive: isActive
                    };
                    Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["v" /* setToken */])(tokens);
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_135" /* CORE_VERIFY_LOGIN_FAILURE */], {
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.error;
                });
            }
        }]
    });
}

function acceptTerm(history) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/agreetm',
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["e" /* CORE_ACCEPT_TERM_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["f" /* CORE_ACCEPT_TERM_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["u" /* setIsAgree */])();
                    return json.value;
                });
            },
            callBack: function callBack() {
                history.push("/");
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* CORE_ACCEPT_TERM_FAILURE */]]
    });
}

function sendReport(body) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/userreport',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_130" /* CORE_SEND_REPORT_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_131" /* CORE_SEND_REPORT_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return [json.value];
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_129" /* CORE_SEND_REPORT_FAILURE */]]
    });
}

function firstChangePassword(state, history) {
    var current = state.current,
        password = state.password,
        confirmPassword = state.confirmPassword,
        accessToken = state.accessToken;

    var body = {
        "code": current,
        "newPassword": password,
        "confirmPassword": confirmPassword
    };
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/changepass/code',
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_1" /* CORE_FIRST_CHANGE_PASSWORD_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_2" /* CORE_FIRST_CHANGE_PASSWORD_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            },
            callBack: function callBack() {
                Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["f" /* clearBSRSToken */])();
                Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["h" /* clearToken */])();
                // window.location.replace(`/login`)
                history.push('/login');
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_0" /* CORE_FIRST_CHANGE_PASSWORD_FAILURE */]]
    });
}

function sendEmailVerifyCode(accessToken, userId, isNew) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/changepass',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        },
        types: [__WEBPACK_IMPORTED_MODULE_1__types__["_4" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_1__types__["_5" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            },
            callBack: function callBack() {
                // clearBSRSToken()
                Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["f" /* clearBSRSToken */])();
                Object(__WEBPACK_IMPORTED_MODULE_2_Lib__["h" /* clearToken */])();
                if (isNew) {
                    window.location.replace('/changepassword/' + userId + '?firsttime=true');
                }
            }
        }, __WEBPACK_IMPORTED_MODULE_1__types__["_3" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE */]]
    });
}

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(79);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var es = __webpack_require__(71);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(119);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var react_redux_es = __webpack_require__(32);

// EXTERNAL MODULE: ./src/features/auth/actions.js
var actions = __webpack_require__(670);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(232);

// EXTERNAL MODULE: ./src/features/rooms/selectors.js
var rooms_selectors = __webpack_require__(667);

// EXTERNAL MODULE: ./src/features/rooms/actions.js
var rooms_actions = __webpack_require__(333);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(44);

// EXTERNAL MODULE: ./src/core/business/MyManager.js
var MyManager = __webpack_require__(336);

// CONCATENATED MODULE: ./src/business/RoomManager.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RoomManager_RoomManager = function (_MyManager) {
	_inherits(RoomManager, _MyManager);

	function RoomManager() {
		_classCallCheck(this, RoomManager);

		return _possibleConstructorReturn(this, (RoomManager.__proto__ || Object.getPrototypeOf(RoomManager)).apply(this, arguments));
	}

	_createClass(RoomManager, [{
		key: 'findAllRoom',
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
				var options, res;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								options = {
									method: this.requestMethod.GET,
									url: lib["a" /* CORE_API_ENDPOINT */] + '/rooms/search',
									data: data
								};
								_context.next = 4;
								return this.requestAction(options, null);

							case 4:
								res = _context.sent;
								return _context.abrupt('return', res);

							case 8:
								_context.prev = 8;
								_context.t0 = _context['catch'](0);
								return _context.abrupt('return', false);

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[0, 8]]);
			}));

			function findAllRoom(_x) {
				return _ref.apply(this, arguments);
			}

			return findAllRoom;
		}()
	}]);

	return RoomManager;
}(MyManager["a" /* default */]);

/* harmony default export */ var business_RoomManager = (RoomManager_RoomManager);
// EXTERNAL MODULE: ./src/features/ui/components/Loading.js
var Loading = __webpack_require__(664);

// CONCATENATED MODULE: ./src/business/ReportManager.js
var ReportManager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReportManager__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function ReportManager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReportManager__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReportManager__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ReportManager_ReportManager = function (_MyManager) {
	ReportManager__inherits(ReportManager, _MyManager);

	function ReportManager() {
		ReportManager__classCallCheck(this, ReportManager);

		return ReportManager__possibleConstructorReturn(this, (ReportManager.__proto__ || Object.getPrototypeOf(ReportManager)).apply(this, arguments));
	}

	ReportManager__createClass(ReportManager, [{
		key: 'sendReport',
		value: function () {
			var _ref = ReportManager__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
				var options, res;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								options = {
									method: this.requestMethod.POST,
									url: lib["a" /* CORE_API_ENDPOINT */] + '/userreport',
									data: data
								};
								_context.next = 4;
								return this.requestAction(options, null);

							case 4:
								res = _context.sent;
								return _context.abrupt('return', res);

							case 8:
								_context.prev = 8;
								_context.t0 = _context['catch'](0);
								return _context.abrupt('return', false);

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[0, 8]]);
			}));

			function sendReport(_x) {
				return _ref.apply(this, arguments);
			}

			return sendReport;
		}()
	}]);

	return ReportManager;
}(MyManager["a" /* default */]);

/* harmony default export */ var business_ReportManager = (ReportManager_ReportManager);
// CONCATENATED MODULE: ./src/features/ui/components/Model/Report.js
var Report__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Report__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Report__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Report__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Report__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Report_CustomModel = function (_Component) {
    Report__inherits(CustomModel, _Component);

    function CustomModel(props) {
        var _this2 = this;

        Report__classCallCheck(this, CustomModel);

        var _this = Report__possibleConstructorReturn(this, (CustomModel.__proto__ || Object.getPrototypeOf(CustomModel)).call(this, props));

        _this.onGetRoom = function () {
            _this.setState({
                isLoading: true
            }, Report__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var res, tempState;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.bRoom.findAllRoom();

                            case 2:
                                res = _context.sent;
                                tempState = {
                                    rooms: [],
                                    isLoading: false
                                };

                                if (!!res && res.result === true) {
                                    if (Array.isArray(res.data)) {
                                        tempState.rooms = res.data;
                                    }
                                }
                                _this.setState(tempState);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            })));
        };

        _this.handleChange = function (e, _ref2) {
            var value = _ref2.value,
                name = _ref2.name;
            return _this.setState(_defineProperty({}, name, value));
        };

        _this.validate = function () {
            var isValid = true,
                tempState = {};
            var _this$state = _this.state,
                content = _this$state.content,
                room = _this$state.room;

            if (!!content) {
                tempState.contentValid = "";
            } else {
                isValid = false;
                tempState.contentValid = "Require!!";
            }
            if (!!room && room !== "0") {
                tempState.roomValid = "";
            } else {
                isValid = false;
                tempState.roomValid = "Require!!";
            }
            _this.setState(tempState, function () {
                if (isValid) {
                    _this.onSendReport();
                }
            });
        };

        _this.onSendReport = function () {
            _this.setState({
                isLoading: true
            }, Report__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this$state2, content, room, body, res, tempState, action;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this$state2 = _this.state, content = _this$state2.content, room = _this$state2.room;
                                body = {
                                    detail: content,
                                    roomId: room,
                                    userId: Object(lib["p" /* getUserId */])()
                                    // roomName: room,
                                    // ReportBy: getfullName()
                                };
                                _context2.next = 4;
                                return _this.bReport.sendReport(body);

                            case 4:
                                res = _context2.sent;
                                tempState = {
                                    isLoading: false
                                }, action = function action() {};

                                if (!!res && res.result === true) {
                                    action = _this.props.onClose;
                                } else {
                                    tempState.customModal = {
                                        open: true,
                                        content: react_default.a.createElement(
                                            'div',
                                            null,
                                            !!res && Array.isArray(res.errors) && res.errors.length > 0 ? react_default.a.createElement(
                                                'div',
                                                null,
                                                res.errors.map(function (err, i) {
                                                    return react_default.a.createElement(
                                                        'div',
                                                        { key: i },
                                                        react_default.a.createElement(
                                                            'p',
                                                            null,
                                                            'Error Code : ',
                                                            err.code
                                                        ),
                                                        react_default.a.createElement(
                                                            'p',
                                                            null,
                                                            'Error Message : ',
                                                            err.message
                                                        )
                                                    );
                                                })
                                            ) : react_default.a.createElement(
                                                react_default.a.Fragment,
                                                null,
                                                react_default.a.createElement(
                                                    'p',
                                                    null,
                                                    'Error Code : '
                                                ),
                                                react_default.a.createElement(
                                                    'p',
                                                    null,
                                                    'Error Message : '
                                                )
                                            )
                                        ),
                                        onCose: function onCose() {
                                            _this.setState({
                                                customModal: null
                                            });
                                        }
                                    };
                                }
                                _this.setState(tempState, action);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            })));
        };

        _this.state = {
            // open: open,
            contentValid: '',
            roomValid: '',
            content: '',
            room: '0',

            rooms: [],
            isLoading: false,

            customModal: null
        };
        _this.bRoom = new business_RoomManager();
        _this.bReport = new business_ReportManager();
        return _this;
    }

    Report__createClass(CustomModel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.onGetRoom();
        }
    }, {
        key: 'selected',
        value: function selected() {
            this.validate(this.state);
        }
    }, {
        key: 'render',
        value: function render() {
            var onClose = this.props.onClose;
            var _state = this.state,
                dimmer = _state.dimmer,
                rooms = _state.rooms,
                room = _state.room,
                isLoading = _state.isLoading,
                customModal = _state.customModal;


            var name = Object(lib["q" /* getfullName */])();
            var report = 'Report By : ' + name;

            var optionsRoom = [{
                key: "0",
                value: "0",
                text: "-- Please Select --"
            }];
            rooms.forEach(function (r) {
                optionsRoom.push({
                    key: r._id,
                    value: r._id,
                    text: r.name
                });
            });
            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(
                    dist_es["q" /* Modal */],
                    { open: true, dimmer: dimmer, className: 'modalDanger' },
                    isLoading && react_default.a.createElement(Loading["a" /* default */], null),
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Header,
                        { style: { textAlign: 'center' } },
                        'Report Administrator'
                    ),
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Content,
                        null,
                        react_default.a.createElement(
                            dist_es["q" /* Modal */].Description,
                            null,
                            react_default.a.createElement(
                                dist_es["g" /* Form */],
                                null,
                                react_default.a.createElement(
                                    dist_es["h" /* Grid */],
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Grid */].Row,
                                        { style: { padding: 0 } },
                                        react_default.a.createElement(
                                            dist_es["h" /* Grid */].Column,
                                            { width: 13 },
                                            react_default.a.createElement(dist_es["g" /* Form */].Field, { control: dist_es["u" /* TextArea */], label: 'Content', name: 'content', placeholder: 'Reason', onChange: this.handleChange, style: { display: 'inline' } })
                                        ),
                                        react_default.a.createElement(
                                            dist_es["h" /* Grid */].Column,
                                            { width: 3, verticalAlign: 'middle' },
                                            react_default.a.createElement(
                                                'div',
                                                { className: 'errors' },
                                                this.state.contentValid
                                            )
                                        )
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Grid */].Row,
                                        null,
                                        react_default.a.createElement(
                                            dist_es["h" /* Grid */].Column,
                                            { width: 16, verticalAlign: 'middle' },
                                            react_default.a.createElement(
                                                'p',
                                                { style: { fontWeight: "bold" } },
                                                'Room'
                                            )
                                        ),
                                        react_default.a.createElement(
                                            dist_es["h" /* Grid */].Column,
                                            { width: 8 },
                                            react_default.a.createElement(dist_es["f" /* Dropdown */], {
                                                search: true,
                                                selection: true,
                                                options: optionsRoom,
                                                fluid: true,
                                                value: room,
                                                name: 'room',
                                                onChange: this.handleChange
                                            })
                                        ),
                                        react_default.a.createElement(
                                            dist_es["h" /* Grid */].Column,
                                            { width: 3, verticalAlign: 'middle' },
                                            react_default.a.createElement(
                                                'div',
                                                { className: 'errors' },
                                                this.state.roomValid
                                            )
                                        )
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Grid */].Row,
                                        { style: { padding: 0 } },
                                        react_default.a.createElement(
                                            dist_es["h" /* Grid */].Column,
                                            { width: 16, verticalAlign: 'middle' },
                                            react_default.a.createElement(dist_es["g" /* Form */].Field, { label: report })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Actions,
                        null,
                        react_default.a.createElement(
                            dist_es["a" /* Button */],
                            { color: 'blue', style: { width: '100px' }, onClick: this.validate },
                            'Ok'
                        ),
                        react_default.a.createElement(
                            dist_es["a" /* Button */],
                            { color: 'grey', style: { width: '100px' }, onClick: onClose },
                            'Cancel'
                        )
                    )
                ),
                !!customModal && react_default.a.createElement(
                    dist_es["q" /* Modal */],
                    { open: customModal.open, onClose: this.close },
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Header,
                        null,
                        'Something went wrong !'
                    ),
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Content,
                        null,
                        react_default.a.createElement(
                            dist_es["q" /* Modal */].Description,
                            null,
                            customModal.content
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["q" /* Modal */].Actions,
                        null,
                        react_default.a.createElement(dist_es["a" /* Button */], {
                            positive: true,
                            icon: 'checkmark',
                            labelPosition: 'right',
                            content: 'OK',
                            onClick: customModal.onCose
                        })
                    )
                )
            );
        }
    }]);

    return CustomModel;
}(react["Component"]);

/* harmony default export */ var Report = (Report_CustomModel);
// EXTERNAL MODULE: ./src/features/user/actions.js
var user_actions = __webpack_require__(668);

// EXTERNAL MODULE: ./src/features/user/selectors.js
var user_selectors = __webpack_require__(335);

// EXTERNAL MODULE: ./src/features/ui/components/ErrorMessage.js
var ErrorMessage = __webpack_require__(663);

// EXTERNAL MODULE: ./src/features/ui/selectors.js
var ui_selectors = __webpack_require__(330);

// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(261);

// CONCATENATED MODULE: ./src/features/ui/components/Header.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// import Loading from 'Features/ui/components/Loading'




// import Routes from './Routes'

var H3 = {
	color: "#fff",
	padding: "10px",
	position: "relative",
	width: '100%'

	// const gridMenuStyle = {
	// 	backgroundColor: '#010101',
	// 	color: '#fff',
	// 	padding: '0',
	// 	textAlign: 'center',
	// 	marginTop: '-10px',
	// }


	// const Border = {
	// 	color: '#fff',
	// 	padding: '10px',
	// 	height: '30px',
	// }

	// const BorderWithGrayBackground = {
	// 	backgroundColor: '#9DC2E1',
	// 	color: '#fff',
	// 	padding: '10px',
	// 	height: '30px',
	// }
};var Header_MenuConst = function MenuConst(props) {
	var home = function home() {
		// props.clearStateFormSearchName()
		window.location.replace('/');
	};
	var userManual = function userManual(userManualLink) {
		if (!userManualLink.toString().toLowerCase().startsWith("http://") && !userManualLink.toString().toLowerCase().startsWith("https://")) {
			window.location = 'https://' + userManualLink.toString().trim();
		} else window.location = userManualLink.toString().trim();
	};
	var logout = function logout() {
		Object(lib["h" /* clearToken */])();
		Object(lib["f" /* clearBSRSToken */])();
		props.history.replace('/login');
	};
	return react_default.a.createElement(
		dist_es["h" /* Grid */].Row,
		{ style: { padding: 0, display: 'inline-flex' } },
		react_default.a.createElement(
			dist_es["h" /* Grid */].Column,
			{ style: { padding: 0 }, width: 2 },
			react_default.a.createElement(
				dist_es["p" /* Menu */].Item,
				{
					// as={Link} to='/home'
					onClick: function onClick() {
						return home();
					},
					style: { padding: '5px', margin: 0 } },
				react_default.a.createElement(dist_es["k" /* Image */], {
					size: 'tiny',
					src: '/assets/images/logo_01.png',
					style: { height: '45px', width: 'auto' }
				})
			)
		),
		react_default.a.createElement(
			dist_es["h" /* Grid */].Column,
			{ style: { padding: 0 }, computer: 3, tablet: 10, mobile: 7 },
			react_default.a.createElement(dist_es["p" /* Menu */].Item, { style: { textAlign: 'center' } })
		),
		react_default.a.createElement(
			dist_es["h" /* Grid */].Column,
			{ style: { position: 'absolute', right: 0 }, computer: 2, tablet: 3, mobile: 4 },
			react_default.a.createElement(
				dist_es["p" /* Menu */].Menu,
				{ position: 'right' },
				react_default.a.createElement(
					dist_es["f" /* Dropdown */],
					{ item: true, icon: 'list ul', className: 'font20px', style: { color: '#fff', paddingRight: 0 }, size: 'big' },
					react_default.a.createElement(
						dist_es["f" /* Dropdown */].Menu,
						{ style: { left: '-150px' } },
						react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							{ as: es["b" /* Link */], to: '/information' },
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'user', style: { margin: 0, padding: '5px 15px' } }),
								' User Information'
							)
						),
						react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							{ as: es["b" /* Link */], to: '/viewterm' },
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'info', style: { margin: 0, padding: '5px 15px' } }),
								'Term & Condition'
							)
						),
						react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							{ as: es["b" /* Link */], to: '/floorplan' },
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'building outline', style: { margin: 0, padding: '5px 15px' } }),
								' Floor Plan'
							)
						),
						props.setting.userManualLink && react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							{
								onClick: function onClick() {
									return userManual(props.setting.userManualLink);
								}
							},
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'book', style: { margin: 0, padding: '5px 15px' } }),
								' User Manual'
							)
						),
						react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							{
								onClick: logout
							},
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'sign out alternate', style: { margin: 0, padding: '5px 15px' } }),
								' Logout'
							)
						)
					)
				),
				react_default.a.createElement(
					dist_es["f" /* Dropdown */],
					{ item: true, icon: 'phone', className: 'font20px', style: { color: '#fff' }, size: 'big' },
					react_default.a.createElement(
						dist_es["f" /* Dropdown */].Menu,
						null,
						react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							null,
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ href: 'tel:' + props.setting.technicalPhoneNumber, style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'briefcase', style: { margin: 0, padding: '5px 15px' } }),
								' Technical Support'
							)
						),
						react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							null,
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ href: 'tel:' + props.setting.housekeeperPhoneNumber, style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'bell', style: { margin: 0, padding: '5px 15px' } }),
								' Housekeeper'
							)
						),
						Object(lib["q" /* getfullName */])() !== undefined && react_default.a.createElement(
							dist_es["f" /* Dropdown */].Item,
							{ onClick: function onClick() {
									return props.openModal();
								} },
							react_default.a.createElement(
								dist_es["a" /* Button */],
								{ style: { borderRadius: '50%', padding: '10px', backgroundColor: '#fff' } },
								react_default.a.createElement(dist_es["j" /* Icon */], { name: 'clipboard', style: { margin: 0, padding: '5px 15px' } }),
								' Report Administrator'
							)
						)
					)
				)
			)
		)
	);
};

var Header_MenuConstWithOut = function MenuConstWithOut(props) {
	var home = function home() {
		// props.clearStateFormSearchName()
		window.location.replace('/');
	};
	return react_default.a.createElement(
		dist_es["h" /* Grid */].Row,
		{ style: { padding: 0, display: 'inline-flex' } },
		react_default.a.createElement(
			dist_es["h" /* Grid */].Column,
			{ style: { padding: 0 }, width: 2 },
			react_default.a.createElement(
				dist_es["p" /* Menu */].Item,
				{
					// as={Link} to='/home'
					onClick: function onClick() {
						return home();
					},
					style: { padding: '5px', margin: 0 } },
				react_default.a.createElement(dist_es["k" /* Image */], {
					size: 'tiny',
					src: '/assets/images/logo_01.png',
					style: { height: '45px', width: 'auto' }
				})
			)
		)
	);
};

var width100 = { width: '100%', textAlign: 'center' };

var Header_Header = function (_React$Component) {
	Header__inherits(Header, _React$Component);

	function Header(props) {
		Header__classCallCheck(this, Header);

		var _this = Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

		_this.show = function () {
			return _this.setState({ open: true });
		};

		_this.openModal = function () {
			// this.setState({
			// 	sendReport: [],
			// 	open: true,
			// 	modal: {
			// 		open: true,
			// 		action: (body) => this.props.sendReport(body)
			// 	}
			// })
			_this.setState({
				isOpenModal: true
			});
		};

		_this.close = function () {
			_this.setState({
				open: false,
				sendReport: false
			});
		};

		_this.closeReport = function () {
			_this.setState({
				open: false,
				sendReport: false
			});
			window.location.reload();
		};

		var sendReport = false;
		if (typeof props.hasSendReport !== 'undefined') {
			if (typeof props.hasSendReport[0] !== 'undefined') sendReport = props.hasSendReport[0];
		}

		_this.state = {
			open: false,
			title: "",
			modal: {
				open: false
			},
			sendReport: sendReport,

			isOpenModal: false
		};
		return _this;
	}

	Header__createClass(Header, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(props) {
			if (props.hasSendReport.length > 0) {
				this.setState({
					sendReport: true,
					modal: {
						open: false
					}
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			// const { props } = this
			// const { userInfo } = props
			var props = this.props;
			var isOpenModal = this.state.isOpenModal;

			return react_default.a.createElement(
				'div',
				{ id: 'header' },
				this.state.sendReport && props.keyword && react_default.a.createElement(
					dist_es["q" /* Modal */],
					{ open: this.state.sendReport, onClose: this.close },
					react_default.a.createElement(
						dist_es["q" /* Modal */].Header,
						null,
						'Information'
					),
					react_default.a.createElement(
						dist_es["q" /* Modal */].Content,
						null,
						react_default.a.createElement(
							dist_es["q" /* Modal */].Description,
							null,
							'Your report has been sent to administrator.'
						)
					),
					react_default.a.createElement(
						dist_es["q" /* Modal */].Actions,
						null,
						react_default.a.createElement(
							dist_es["a" /* Button */],
							{ color: 'blue', onClick: function onClick() {
									return _this2.closeReport();
								} },
							'Ok'
						)
					)
				),
				isOpenModal && react_default.a.createElement(Report, { onClose: function onClose() {
						return _this2.setState({ isOpenModal: false });
					} }),
				Object(auth["e" /* getAllToken */])().access_token !== undefined ? react_default.a.createElement(
					'div',
					null,
					props.keyword === "withName" && react_default.a.createElement(
						dist_es["p" /* Menu */],
						{ secondary: true, fixed: 'top', id: 'headerStyle' },
						react_default.a.createElement(
							'div',
							{ style: { width: '100%', margin: 0 } },
							react_default.a.createElement(
								dist_es["c" /* Container */],
								{ style: { position: 'relative' } },
								react_default.a.createElement(Header_MenuConst, _extends({ moduleName: props.moduleName }, props, this))
							)
						)
					),
					props.keyword === "withoutLogo" && react_default.a.createElement(
						dist_es["p" /* Menu */].Menu,
						{ style: width100 },
						react_default.a.createElement(
							dist_es["p" /* Menu */].Item,
							{ style: width100 },
							react_default.a.createElement(
								'h3',
								{ style: H3 },
								props.moduleName
							)
						)
					),
					props.keyword === "onlyLogo" && react_default.a.createElement(
						dist_es["p" /* Menu */],
						{ secondary: true, fixed: 'top', id: 'headerStyle' },
						react_default.a.createElement(
							'div',
							{ style: { width: '100%', margin: 0 } },
							react_default.a.createElement(
								dist_es["c" /* Container */],
								{ style: { position: 'relative' } },
								react_default.a.createElement(Header_MenuConstWithOut, _extends({ moduleName: props.moduleName }, props, this))
							)
						)
					),
					props.keyword === "withBack" && react_default.a.createElement(
						dist_es["h" /* Grid */],
						{ style: { width: '100%', margin: 0 } },
						react_default.a.createElement(
							dist_es["h" /* Grid */].Row,
							{ style: { padding: 0, width: '100%' } },
							react_default.a.createElement(
								dist_es["h" /* Grid */].Column,
								{ width: 2 },
								react_default.a.createElement(
									dist_es["p" /* Menu */].Item,
									{ as: es["b" /* Link */], to: '/' + props.backLink },
									react_default.a.createElement(dist_es["j" /* Icon */], { disabled: true, name: 'chevron left', size: 'large', style: { color: '#fff', marginTop: '8px' } })
								)
							),
							react_default.a.createElement(
								dist_es["h" /* Grid */].Column,
								{ width: 12 },
								react_default.a.createElement(
									dist_es["p" /* Menu */].Item,
									{ style: width100 },
									react_default.a.createElement(
										'h3',
										{ style: H3 },
										props.moduleName
									)
								)
							)
						)
					)
				) : react_default.a.createElement(
					'div',
					null,
					props.keyword === "AmenityService" && react_default.a.createElement(
						dist_es["p" /* Menu */],
						{ secondary: true, fixed: 'top', id: 'headerStyle', style: { height: '70px' } },
						react_default.a.createElement(
							'div',
							{ style: { width: '100%', margin: 0 } },
							react_default.a.createElement(
								dist_es["c" /* Container */],
								{ style: { position: 'relative' } },
								react_default.a.createElement(
									dist_es["h" /* Grid */],
									{ style: { margin: 0, padding: 0 } },
									react_default.a.createElement(
										dist_es["h" /* Grid */].Row,
										{ style: { display: 'inline-flex', padding: 0 } },
										react_default.a.createElement(
											dist_es["h" /* Grid */].Column,
											{ style: { padding: 0 }, width: 4 },
											react_default.a.createElement(
												dist_es["p" /* Menu */].Item,
												{ as: es["b" /* Link */], to: '/', style: { padding: '5px', margin: 0 } },
												react_default.a.createElement(dist_es["k" /* Image */], {
													size: 'tiny',
													src: '/assets/images/logo_01.png',
													style: { height: '45px', width: 'auto' }
												})
											)
										),
										react_default.a.createElement(
											dist_es["h" /* Grid */].Column,
											{ tablet: 8, mobile: 7, computer: 8 },
											react_default.a.createElement(
												'h1',
												{ style: { color: "white", textAlign: "center", marginTop: '13px' } },
												props.moduleName
											)
										),
										react_default.a.createElement(
											dist_es["h" /* Grid */].Column,
											{ tablet: 4, mobile: 5, computer: 4, textAlign: 'left' },
											react_default.a.createElement(
												'span',
												{ style: { color: "white", fontSize: "20px", fontWeight: "bold", display: 'block', marginTop: '5px' } },
												'Floor'
											),
											react_default.a.createElement(dist_es["f" /* Dropdown */], {
												placeholder: 'Select Floor',
												selection: true,
												compact: true,
												name: 'floor'
												// defaultValue={props.default[0].value}
												, value: props.default,
												options: props.floorSelect,
												onChange: props.handleChange,
												style: { width: "100px" } })
										)
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return Header;
}(react_default.a.Component);

/* harmony default export */ var components_Header = __webpack_exports__["a"] = (Object(Recompose["b" /* compose */])(es["f" /* withRouter */], Object(react_redux_es["connect"])(function (state, props) {
	return {
		setting: Object(rooms_selectors["j" /* getSettings */])(state),
		isLoggedIn: Object(selectors["a" /* getIsLoggedIn */])(state),
		userInfo: Object(user_selectors["f" /* getUserInfo */])(state),
		isLoading: Object(ui_selectors["b" /* getIsLoading */])(state),
		hasError: Object(ui_selectors["a" /* getHasError */])(state),
		hasSendReport: Object(user_selectors["b" /* getHasSendReport */])(state)
	};
}, function (dispatch, props) {
	return {
		logout: function logout() {
			dispatch(Object(actions["a" /* logout */])());
			props.history.push('/login');
		},
		loadSetting: function loadSetting() {
			dispatch(Object(rooms_actions["c" /* findDefaultSetting */])());
		},
		clearStateFormSearchName: function clearStateFormSearchName() {
			dispatch(Object(rooms_actions["a" /* clearStateFormSearchName */])());
		},
		sendReport: function sendReport(body) {
			dispatch(Object(user_actions["j" /* sendReport */])(body));
		}
	};
}), Object(Recompose["c" /* lifecycle */])({
	componentDidMount: function componentDidMount() {
		if (this.props.setting.length === 0) this.props.loadSetting();
	}
}),
// branch(props => props.isLoading, renderComponent(Loading)),
Object(Recompose["a" /* branch */])(function (props) {
	return props.hasError;
}, Object(Recompose["d" /* renderComponent */])(ErrorMessage["a" /* default */])))(Header_Header));

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export authorizeBSRS */
/* harmony export (immutable) */ __webpack_exports__["a"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Lib__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Middlewares__ = __webpack_require__(167);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






// export function authorizeO365(code){
//     return {
//         [CALL_API] : {
//             endpoint: `${CORE_API_ENDPOINT}/o365/token`,
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({ code }),
//             types: [
//                 O365_REGISTER_REQUEST,
//                 {
//                     type: O365_REGISTER_SUCCESS,
//                     payload(action, state, res){
//                         return res.json()
//                         .then(json => {
//                             const {
//                                 access_token,
//                                 expires_on,
//                                 refresh_token
//                             } = json

//                             const token = {
//                                 access_token,
//                                 expires_on,
//                                 refresh_token
//                             }

//                             setToken(token)
//                             return { token }
//                         })
//                     }
//                 },
//                 O365_REGISTER_FAILURE            
//             ]
//         }
//     }
// }

function authorizeBSRS(_ref) {
    var email = _ref.email,
        password = _ref.password;

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["a" /* CORE_API_ENDPOINT */] + '/user/verify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email, password: password }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["b" /* BSRS_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* BSRS_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var bsrsToken = json.token;


                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["s" /* setBSRSToken */])(bsrsToken);
                    return { bsrsToken: bsrsToken };
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* BSRS_LOGIN_FAILURE */]]
    });
}

function logout() {
    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["f" /* clearBSRSToken */])();
    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["h" /* clearToken */])();
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__types__["_141" /* LOGOUT */]
    };
}

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(339);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(517);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/constant.js
var constant = __webpack_require__(337);

// CONCATENATED MODULE: ./src/core/business/CookiesManager.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var CookiesManager_CookiesManager = function () {
	function CookiesManager() {
		_classCallCheck(this, CookiesManager);

		this.key = "_data";
		this.expires = 7;
		this.timeZone = "Asia/Bangkok";
	}

	_createClass(CookiesManager, [{
		key: 'encrypt',
		value: function encrypt(data) {
			var step1 = base64_default.a.encode(JSON.stringify(data)),
			    step2 = this.myEncode(step1);

			return step2;
		}
	}, {
		key: 'decrypt',
		value: function decrypt(data) {
			var step1 = this.myDecode(data);
			return JSON.parse(base64_default.a.decode(step1));
		}
	}, {
		key: 'myEncode',
		value: function myEncode(str) {
			try {
				var b64 = base64_default.a.encode(str);
				if (b64.length <= 20) {
					return b64;
				}

				var pre = b64.substr(0, 10),
				    sub = b64.substr(b64.length - 10, 10),
				    con = b64.substr(10, b64.length - 20);

				return con + pre + sub;
			} catch (error) {
				throw error;
			}
		}
	}, {
		key: 'myDecode',
		value: function myDecode(b64) {
			try {
				if (b64.length <= 20) {
					return base64_default.a.decode(b64);
				}

				var pre = b64.substr(b64.length - 20, 10),
				    sub = b64.substr(b64.length - 10, 10),
				    con = b64.substr(0, b64.length - 20);

				return base64_default.a.decode(pre + con + sub);
			} catch (error) {
				throw error;
			}
		}
	}, {
		key: 'setDataCookies',
		value: function setDataCookies(data) {
			try {
				if (data) {
					var expires = null;
					try {
						if (!!data[constant["a" /* cookiesKey */].IS_REMEMBER]) {
							expires = { expires: this.expires };
						}
					} catch (error) {}
					js_cookie_default.a.set(this.key, this.encrypt(data), expires);
				}
			} catch (error) {}
		}
	}, {
		key: 'getDataCookies',
		value: function getDataCookies() {
			try {
				var data = js_cookie_default.a.get(this.key);
				if (data) {
					var dataDecrypt = this.decrypt(data);
					this.resetExpireDate(dataDecrypt);
					return dataDecrypt;
				}
			} catch (error) {}

			return null;
		}
	}, {
		key: 'removeDataCookies',
		value: function removeDataCookies() {
			try {
				js_cookie_default.a.remove(this.key);
			} catch (error) {}

			return null;
		}
	}, {
		key: 'getData',
		value: function getData(key) {
			try {
				var cookiesData = this.getDataCookies();
				if (key in cookiesData) {
					return cookiesData[key];
				}

				return null;
			} catch (error) {
				return null;
			}
		}
	}, {
		key: 'setData',
		value: function setData(key, value) {
			try {
				var cookiesData = this.getDataCookies();
				if (!cookiesData) {
					cookiesData = {};
				}

				cookiesData[key] = value;
				this.setDataCookies(cookiesData);
			} catch (error) {}
		}
	}, {
		key: 'setDatas',
		value: function setDatas(datas) {
			try {
				if (!datas) {
					throw new Error("Invalid datas");
				}

				var cookiesData = this.getDataCookies();
				if (!cookiesData) {
					cookiesData = {};
				}

				for (var key in datas) {
					cookiesData[key] = datas[key];
				}

				this.setDataCookies(cookiesData);
			} catch (error) {}
		}
	}, {
		key: 'removeData',
		value: function removeData(key) {
			try {
				var cookiesData = this.getDataCookies();
				if (key in cookiesData) {
					delete cookiesData[key];
				}

				this.setDataCookies(cookiesData);
			} catch (error) {}
		}
	}, {
		key: 'removeAll',
		value: function removeAll() {
			try {
				this.removeDataCookies();
			} catch (error) {}
		}
	}, {
		key: 'hasData',
		value: function hasData(key) {
			try {
				var cookiesData = this.getDataCookies();
				return key in cookiesData;
			} catch (error) {
				return false;
			}
		}
	}, {
		key: 'resetExpireDate',
		value: function resetExpireDate(cookiesData) {
			try {
				if (!!cookiesData && cookiesData[constant["a" /* cookiesKey */].IS_REMEMBER] === true) {
					this.setDataCookies(cookiesData);
				}
			} catch (error) {}
		}
	}]);

	return CookiesManager;
}();

/* harmony default export */ var business_CookiesManager = (CookiesManager_CookiesManager);
// CONCATENATED MODULE: ./src/business/CookieAmenityServiceManager.js
function CookieAmenityServiceManager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var CookieAmenityServiceManager = function (_CookiesManager) {
    _inherits(CookieAmenityServiceManager, _CookiesManager);

    function CookieAmenityServiceManager() {
        CookieAmenityServiceManager__classCallCheck(this, CookieAmenityServiceManager);

        var _this = _possibleConstructorReturn(this, (CookieAmenityServiceManager.__proto__ || Object.getPrototypeOf(CookieAmenityServiceManager)).call(this));

        _this.key = "amenity_service_data";
        return _this;
    }

    return CookieAmenityServiceManager;
}(business_CookiesManager);

/* harmony default export */ var business_CookieAmenityServiceManager = __webpack_exports__["a"] = (CookieAmenityServiceManager);

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(678);


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__features_ui_components_Root__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__features_ui_components_Root__);






var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_4__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(888);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var es = __webpack_require__(71);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var react_redux_es = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(895);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(896);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(79);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(44);

// EXTERNAL MODULE: ./src/business/CookieAmenityServiceManager.js + 1 modules
var CookieAmenityServiceManager = __webpack_require__(674);

// EXTERNAL MODULE: ./src/constant.js
var constant = __webpack_require__(337);

// CONCATENATED MODULE: ./src/policy/AmenityServiceRoutePermission.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AmenityServiceRoutePermission_AmenityServiceRoutePermission = function (_React$Component) {
    _inherits(AmenityServiceRoutePermission, _React$Component);

    function AmenityServiceRoutePermission(props) {
        _classCallCheck(this, AmenityServiceRoutePermission);

        var _this = _possibleConstructorReturn(this, (AmenityServiceRoutePermission.__proto__ || Object.getPrototypeOf(AmenityServiceRoutePermission)).call(this, props));

        _this.isAuthenticated = function () {
            var token = _this.bCookie.getData(constant["a" /* cookiesKey */].TOKEN);
            // , tokenExpired = this.bCookie.getData(cookiesKey.REFRESH_TOKEN_EXPIRES_DATE)

            return !!token;
            // && moment().isBefore(moment(tokenExpired))
        };

        _this.getPathCurrent = function () {
            try {
                var location = _this.props.location;

                var pathCurrent = "/";
                if (!!location && !!location.pathname && typeof location.pathname === 'string') {
                    pathCurrent = location.pathname;
                }
                return pathCurrent;
            } catch (error) {
                return "/";
            }
        };

        _this.getComponentRoute = function () {
            try {
                var _this$props = _this.props,
                    component = _this$props.component,
                    path = _this$props.path;


                var obj = {
                    Component: null,
                    path: path,
                    props: null
                };

                var propsRouter = {};
                if (!!component) {
                    obj.Component = component;
                }
                if ("exact" in _this.props) {
                    propsRouter.exact = true;
                }
                obj.props = propsRouter;
                return obj;
            } catch (error) {
                return {
                    Component: null,
                    path: ",",
                    props: null
                };
            }
        };

        var _getAllToken = Object(lib["k" /* getAllToken */])(),
            access_token = _getAllToken.access_token;

        _this.bCookie = new CookieAmenityServiceManager["a" /* default */]();
        var data = _this.bCookie.getDataCookies();
        if (!!access_token) {
            Object(lib["f" /* clearBSRSToken */])();
            Object(lib["h" /* clearToken */])();
            if (!!data) {
                _this.bCookie.setDataCookies(data);
            }
        }
        return _this;
    }

    return AmenityServiceRoutePermission;
}(react_default.a.Component);

AmenityServiceRoutePermission_AmenityServiceRoutePermission.defaultProps = {
    component: null
};

/* harmony default export */ var policy_AmenityServiceRoutePermission = (AmenityServiceRoutePermission_AmenityServiceRoutePermission);
// CONCATENATED MODULE: ./src/policy/PrivateAmenityServiceRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PrivateAmenityServiceRoute__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PrivateAmenityServiceRoute__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PrivateAmenityServiceRoute__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PrivateAmenityServiceRoute_PrivateAmenityServiceRoute = function (_AmenityServiceRouteP) {
    PrivateAmenityServiceRoute__inherits(PrivateAmenityServiceRoute, _AmenityServiceRouteP);

    function PrivateAmenityServiceRoute() {
        PrivateAmenityServiceRoute__classCallCheck(this, PrivateAmenityServiceRoute);

        return PrivateAmenityServiceRoute__possibleConstructorReturn(this, (PrivateAmenityServiceRoute.__proto__ || Object.getPrototypeOf(PrivateAmenityServiceRoute)).apply(this, arguments));
    }

    _createClass(PrivateAmenityServiceRoute, [{
        key: 'render',
        value: function render() {
            var pathCurrent = this.getPathCurrent();
            if (!this.isAuthenticated() && pathCurrent !== "/amenityservice/login") {
                return react_default.a.createElement(es["c" /* Redirect */], { to: '/amenityservice/login' });
            }
            var data = this.getComponentRoute();
            return react_default.a.createElement(es["d" /* Route */], _extends({}, data.props, { path: data.path, component: data.Component }));
        }
    }]);

    return PrivateAmenityServiceRoute;
}(policy_AmenityServiceRoutePermission);

PrivateAmenityServiceRoute_PrivateAmenityServiceRoute.defaultProps = {
    component: null,
    path: ""
};

var enhance = Object(Recompose["b" /* compose */])(es["f" /* withRouter */]);

/* harmony default export */ var policy_PrivateAmenityServiceRoute = (enhance(PrivateAmenityServiceRoute_PrivateAmenityServiceRoute));
// CONCATENATED MODULE: ./src/policy/PublicAmenityServiceRoute.js
var PublicAmenityServiceRoute__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PublicAmenityServiceRoute__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PublicAmenityServiceRoute__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PublicAmenityServiceRoute__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PublicAmenityServiceRoute__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PublicAmenityServiceRoute_PublicAmenityServiceRoute = function (_AmenityServiceRouteP) {
    PublicAmenityServiceRoute__inherits(PublicAmenityServiceRoute, _AmenityServiceRouteP);

    function PublicAmenityServiceRoute() {
        PublicAmenityServiceRoute__classCallCheck(this, PublicAmenityServiceRoute);

        return PublicAmenityServiceRoute__possibleConstructorReturn(this, (PublicAmenityServiceRoute.__proto__ || Object.getPrototypeOf(PublicAmenityServiceRoute)).apply(this, arguments));
    }

    PublicAmenityServiceRoute__createClass(PublicAmenityServiceRoute, [{
        key: 'render',
        value: function render() {
            var pathCurrent = this.getPathCurrent();
            if (this.isAuthenticated() && pathCurrent === "/amenityservice/login") {
                return react_default.a.createElement(es["c" /* Redirect */], { to: '/amenityservice' });
            }
            var data = this.getComponentRoute();
            return react_default.a.createElement(es["d" /* Route */], PublicAmenityServiceRoute__extends({}, data.props, { path: data.path, component: data.Component }));
        }
    }]);

    return PublicAmenityServiceRoute;
}(policy_AmenityServiceRoutePermission);

PublicAmenityServiceRoute_PublicAmenityServiceRoute.defaultProps = {
    component: null,
    path: ""
};

var PublicAmenityServiceRoute_enhance = Object(Recompose["b" /* compose */])(es["f" /* withRouter */]);

/* harmony default export */ var policy_PublicAmenityServiceRoute = (PublicAmenityServiceRoute_enhance(PublicAmenityServiceRoute_PublicAmenityServiceRoute));
// EXTERNAL MODULE: ./src/features/ui/components/Loadable.js
var Loadable = __webpack_require__(666);

// CONCATENATED MODULE: ./src/features/ui/components/Routes.js






// const AsyncHome = Loadable({
//     loader: () => import(/* webpackChunkName: "Home" */ '../../ui/components/Home')
// })

var AsyncTermAndCondition = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1722));
    }
});

var AsyncNotFound = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1723));
    }
});

var AsyncLoginO365 = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1724));
    }
});

var AsyncAuthorizeO365 = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1725));
    }
});

var AsyncHomeMenu = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1726));
    }
});

var AsyncTimeSlot = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1727));
    }
});

var AsyncCreate = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1728));
    }
});

var AsyncReservationFor = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1729));
    }
});

var AsyncAttendee = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1730));
    }
});

var AsyncAttendeeEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1731));
    }
});

var AsyncOrder = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1732));
    }
});

var AsyncCreateOrder = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1733));
    }
});

var AsyncEditOrder = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1734));
    }
});

var AsyncOrderEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1735));
    }
});

// const AsyncAmenity = Loadable({
//     loader: () => import('../../ui/components/Amenity')
// })

var AsyncAmenityEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1736));
    }
});

var AsyncConfirm = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1737));
    }
});

var AsyncMyReservationComing = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1738));
    }
});

var AsyncMyReservationHistory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1739));
    }
});

var AsyncMyReservationDay = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1740));
    }
});

var AsyncEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1741));
    }
});

var AsyncQrcode = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1742));
    }
});

var AsyncCheckInSuccess = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1743));
    }
});

var AsyncCheckOutSuccess = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1744));
    }
});

var AsyncCheckOutFail = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1745));
    }
});

var AsyncCheckInFail = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1746));
    }
});

var AsyncFloorPlan = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1747));
    }
});

var AsyncInformation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1748));
    }
});

var AsyncAccessDenied = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1749));
    }
});

var AsyncLogin = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1750));
    }
});

var AsyncLoginADFS = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1751));
    }
});

var VerifyOauth = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1752));
    }
});

var AsyncSearchRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1753));
    }
});

var AsyncReservationForEdit = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1754));
    }
});

var AsyncEventHistory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1755));
    }
});

var AsyncFloorPlanNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1756));
    }
});

// const AsynRoomSlots = Loadable({
//     loader: () => import('../../rooms/components/RoomSlot')
// })

var AsynSlot = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1757));
    }
});
// const AsynRoomSlotsID = Loadable({
//     loader: () => import('../../rooms/components/RoomSlotID')
// })

var AsyncSearchRoomSuggest = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1758));
    }
});

var AsyndcViewEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1759));
    }
});

var AsyndcViewEventScan = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1760));
    }
});

var AsyndcCheckIn = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1761));
    }
});

var AsyndcCreateEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1762));
    }
});

var AsyndcCreateEventTraining = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1763));
    }
});

var AsyncMyReservationComingNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1764));
    }
});

var AsyncMyReservationHistoryNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1765));
    }
});

var AsyncMyReservationDayNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1766));
    }
});

var AsyncEditEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1767));
    }
});

var AsyncEditEventTraining = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1768));
    }
});

var AsyncCreateEventSuccess = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1769));
    }
});

var AsyncEditEventSuccess = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1770));
    }
});

var AsyncVerifyBypass = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1771));
    }
});

var AsyncContact = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1772));
    }
});

var AsyncRoomQr = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1773));
    }
});

var AsyncRoomQrIOS = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1774));
    }
});

var AsyncRoomQrCheckin = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1775));
    }
});

// const AsyncSearchRoomName = Loadable({
//     loader: () => import('../../rooms/components/SearchRoomName')
// })

var AsyncSearchRoomNameHome = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1776));
    }
});

var AsyncSearchRoomNameResult = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1777));
    }
});

var AsyncAmenityService = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1778));
    }
});

var AsyncAmenityServiceLogin = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1781));
    }
});

var AsyncViewEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1782));
    }
});

var AsyncFbs = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1783));
    }
});

var AsyncChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1784));
    }
});

var AsyncFirstChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1785));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["e" /* Switch */],
        null,
        react_default.a.createElement(policy_PrivateAmenityServiceRoute, { path: '/amenityservice/vieworder/:type/:id', component: AsyncViewEvent }),
        react_default.a.createElement(policy_PrivateAmenityServiceRoute, { path: '/amenityservice/login', component: AsyncAmenityServiceLogin }),
        react_default.a.createElement(policy_PrivateAmenityServiceRoute, { path: '/amenityservice', component: AsyncAmenityService }),
        react_default.a.createElement(es["d" /* Route */], { path: '/verifyoauth', component: VerifyOauth }),
        react_default.a.createElement(es["d" /* Route */], { path: '/roomSlots/:path/:id/:date/:start/:end', component: AsynSlot }),
        react_default.a.createElement(es["d" /* Route */], { path: '/roomSlots/:path/:id', component: AsynSlot }),
        react_default.a.createElement(es["d" /* Route */], { path: '/verifybypass/:id/:email', component: AsyncVerifyBypass }),
        react_default.a.createElement(es["d" /* Route */], { path: '/loginadfs', component: AsyncLoginADFS }),
        react_default.a.createElement(es["d" /* Route */], { path: '/login', component: AsyncLogin }),
        react_default.a.createElement(es["d" /* Route */], { path: '/contact', component: AsyncContact }),
        react_default.a.createElement(es["d" /* Route */], { path: '/viewterm', component: AsyncTermAndCondition }),
        react_default.a.createElement(es["d" /* Route */], { path: '/term', component: AsyncTermAndCondition }),
        react_default.a.createElement(es["d" /* Route */], { path: '/logino365', component: AsyncLoginO365 }),
        react_default.a.createElement(es["d" /* Route */], { path: '/authorize', component: AsyncAuthorizeO365 }),
        react_default.a.createElement(es["d" /* Route */], { path: '/information', component: AsyncInformation }),
        react_default.a.createElement(es["d" /* Route */], { path: '/menu', component: AsyncHomeMenu }),
        react_default.a.createElement(es["d" /* Route */], { path: '/qrcode/:room/:event', component: AsyncRoomQrCheckin }),
        react_default.a.createElement(es["d" /* Route */], { path: '/qrcodeios', component: AsyncRoomQrIOS }),
        react_default.a.createElement(es["d" /* Route */], { path: '/qrcode', component: AsyncRoomQr }),
        react_default.a.createElement(es["d" /* Route */], { path: '/orders/:type/:eventId', component: AsyncOrder }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createorder/:type/:eventId', component: AsyncCreateOrder }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editorder/:type/:eventId/:orderId', component: AsyncEditOrder }),
        react_default.a.createElement(es["d" /* Route */], { path: '/fbs/:orderId', component: AsyncFbs }),
        react_default.a.createElement(es["d" /* Route */], { path: '/orderEdit', component: AsyncOrderEdit }),
        react_default.a.createElement(es["d" /* Route */], { path: '/amenityEdit', component: AsyncAmenityEdit }),
        react_default.a.createElement(es["d" /* Route */], { path: '/myreservationHistory', component: AsyncMyReservationHistoryNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/myreservationComing', component: AsyncMyReservationComingNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/myreservationDay', component: AsyncMyReservationDayNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/vieweventScan/:id', component: AsyndcViewEventScan }),
        react_default.a.createElement(es["d" /* Route */], { path: '/viewevent/:id', component: AsyndcViewEvent }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createevent/:path/:id/:single/:startDate/:endDate/:startTime/:endTime', component: AsyndcCreateEvent }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createevent/:path/:id', component: AsyndcCreateEvent }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createeventTraining/:path/:id/:single/:startDate/:endDate/:startTime/:endTime', component: AsyndcCreateEventTraining }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createeventTraining/:path/:id', component: AsyndcCreateEventTraining }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createsuccess/:eventid', component: AsyncCreateEventSuccess }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editevent/:type/:id', component: AsyncEditEvent }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editeventTraining/:type/:id', component: AsyncEditEventTraining }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editsuccess/:eventid', component: AsyncEditEventSuccess }),
        react_default.a.createElement(es["d" /* Route */], { path: '/checkin/:id', component: AsyndcCheckIn }),
        react_default.a.createElement(es["d" /* Route */], { path: '/floorplan', component: AsyncFloorPlanNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/roomsuggest', component: AsyncSearchRoomSuggest }),
        react_default.a.createElement(es["d" /* Route */], { path: '/search/:text', component: AsyncSearchRoomNameResult }),
        react_default.a.createElement(es["d" /* Route */], { path: '/search/', component: AsyncSearchRoomNameResult }),
        react_default.a.createElement(es["d" /* Route */], { path: '/reset/:email', component: AsyncChangePassword }),
        react_default.a.createElement(es["d" /* Route */], { path: '/changepassword/:id', component: AsyncFirstChangePassword }),
        react_default.a.createElement(es["d" /* Route */], { path: '/', component: AsyncSearchRoomNameHome }),
        react_default.a.createElement(es["d" /* Route */], { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/App.js


// import { Container} from 'semantic-ui-react'

/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(Routes, null)
        )
    );
});
// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(119);

// EXTERNAL MODULE: ./src/features/ui/components/Header.js + 3 modules
var Header = __webpack_require__(669);

// EXTERNAL MODULE: ./src/features/ui/components/AuthFooter.js
var AuthFooter = __webpack_require__(665);

// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js









var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
    return react_default.a.createElement(
        react_redux_es["Provider"],
        { store: store },
        react_default.a.createElement(
            es["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(Header["a" /* default */], { moduleName: '', keyword: 'withName' }),
                react_default.a.createElement(
                    dist_es["c" /* Container */],
                    null,
                    react_default.a.createElement(App, null)
                ),
                react_default.a.createElement(AuthFooter["a" /* default */], null)
            )
        )
    );
});

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(897);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 897:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(146);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(898);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(167);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(671);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(1027);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(33);

// CONCATENATED MODULE: ./src/features/ui/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
};

/* harmony default export */ var reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["_64" /* CORE_LOAD_ORDERS_REQUEST */]:
        case types["_91" /* CORE_LOAD_SLOTS_REQUEST */]:
        case types["_70" /* CORE_LOAD_ROOMINFO_REQUEST */]:
        case types["_25" /* CORE_LOAD_EVENTINCOMING_REQUEST */]:
        case types["_139" /* LOAD_ROOMINFO_REQUEST */]:
        case types["_22" /* CORE_LOAD_EVENTHISTORY_REQUEST */]:
        case types["_43" /* CORE_LOAD_FLOORS_REQUEST */]:
        case types["A" /* CORE_CREATE_EVENT_REQUEST */]:
        case types["_7" /* CORE_LOAD_AMENITIES_REQUEST */]:
        case types["b" /* BSRS_LOGIN_REQUEST */]:
        case types["_31" /* CORE_LOAD_EVENTINFO_REQUEST */]:
        case types["V" /* CORE_EDIT_EVENT_REQUEST */]:
        case types["J" /* CORE_DELETE_EVENT_REQUEST */]:
        case types["t" /* CORE_CHECKIN_REQUEST */]:
        case types["_46" /* CORE_LOAD_FLOOR_INFO_REQUEST */]:
        case types["_19" /* CORE_LOAD_EVENTCALENDAR_REQUEST */]:
        case types["_118" /* CORE_SEARCH_ROOMS_REQUEST */]:
        case types["_79" /* CORE_LOAD_ROOMS_SUGGEST_REQUEST */]:
        case types["_133" /* CORE_VERIFY_BYPASS_REQUEST */]:
        case types["_82" /* CORE_LOAD_ROOM_FORMAT_REQUEST */]:
        case types["_88" /* CORE_LOAD_SETTINGS_REQUEST */]:
        case types["_127" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */]:
        case types["n" /* CORE_CHANGE_PASSWORD_REQUEST */]:
        case types["_1" /* CORE_FIRST_CHANGE_PASSWORD_REQUEST */]:
        case types["_130" /* CORE_SEND_REPORT_REQUEST */]:
        case types["_136" /* CORE_VERIFY_LOGIN_REQUEST */]:
        case types["_4" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST */]:
            return _extends({}, state, {
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["_65" /* CORE_LOAD_ORDERS_SUCCESS */]:
        case types["_92" /* CORE_LOAD_SLOTS_SUCCESS */]:
        case types["_71" /* CORE_LOAD_ROOMINFO_SUCCESS */]:
        case types["_140" /* LOAD_ROOMINFO_SUCCESS */]:
        case types["_26" /* CORE_LOAD_EVENTINCOMING_SUCCESS */]:
        case types["_23" /* CORE_LOAD_EVENTHISTORY_SUCCESS */]:
        case types["_44" /* CORE_LOAD_FLOORS_SUCCESS */]:
        case types["B" /* CORE_CREATE_EVENT_SUCCESS */]:
        case types["_8" /* CORE_LOAD_AMENITIES_SUCCESS */]:
        case types["c" /* BSRS_LOGIN_SUCCESS */]:
        case types["_32" /* CORE_LOAD_EVENTINFO_SUCCESS */]:
        case types["W" /* CORE_EDIT_EVENT_SUCCESS */]:
        case types["K" /* CORE_DELETE_EVENT_SUCCESS */]:
        case types["u" /* CORE_CHECKIN_SUCCESS */]:
        case types["_47" /* CORE_LOAD_FLOOR_INFO_SUCCESS */]:
        case types["_20" /* CORE_LOAD_EVENTCALENDAR_SUCCESS */]:
        case types["_119" /* CORE_SEARCH_ROOMS_SUCCESS */]:
        case types["_80" /* CORE_LOAD_ROOMS_SUGGEST_SUCCESS */]:
        case types["_134" /* CORE_VERIFY_BYPASS_SUCCESS */]:
        case types["_83" /* CORE_LOAD_ROOM_FORMAT_SUCCESS */]:
        case types["_89" /* CORE_LOAD_SETTINGS_SUCCESS */]:
        case types["_128" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */]:
        case types["o" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
        case types["_2" /* CORE_FIRST_CHANGE_PASSWORD_SUCCESS */]:
        case types["_131" /* CORE_SEND_REPORT_SUCCESS */]:
        case types["_137" /* CORE_VERIFY_LOGIN_SUCCESS */]:
        case types["_5" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS */]:
            return _extends({}, state, {
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["_63" /* CORE_LOAD_ORDERS_FAILURE */]:
        case types["_42" /* CORE_LOAD_FLOORS_FAILURE */]:
        case types["_69" /* CORE_LOAD_ROOMINFO_FAILURE */]:
        case types["_138" /* LOAD_ROOMINFO_FAILURE */]:
        case types["_90" /* CORE_LOAD_SLOTS_FAILURE */]:
        case types["_24" /* CORE_LOAD_EVENTINCOMING_FAILURE */]:
        case types["_21" /* CORE_LOAD_EVENTHISTORY_FAILURE */]:
        case types["w" /* CORE_CREATE_EVENT_FAILURE */]:
        case types["_6" /* CORE_LOAD_AMENITIES_FAILURE */]:
        case types["a" /* BSRS_LOGIN_FAILURE */]:
        case types["_30" /* CORE_LOAD_EVENTINFO_FAILURE */]:
        case types["U" /* CORE_EDIT_EVENT_FAILURE */]:
        case types["F" /* CORE_DELETE_EVENT_FAILURE */]:
        case types["s" /* CORE_CHECKIN_FAILURE */]:
        case types["_45" /* CORE_LOAD_FLOOR_INFO_FAILURE */]:
        case types["_18" /* CORE_LOAD_EVENTCALENDAR_FAILURE */]:
        case types["_117" /* CORE_SEARCH_ROOMS_FAILURE */]:
        case types["_78" /* CORE_LOAD_ROOMS_SUGGEST_FAILURE */]:
        case types["_132" /* CORE_VERIFY_BYPASS_FAILURE */]:
        case types["_81" /* CORE_LOAD_ROOM_FORMAT_FAILURE */]:
        case types["_87" /* CORE_LOAD_SETTINGS_FAILURE */]:
        case types["_126" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE */]:
        case types["m" /* CORE_CHANGE_PASSWORD_FAILURE */]:
        case types["_0" /* CORE_FIRST_CHANGE_PASSWORD_FAILURE */]:
        case types["_129" /* CORE_SEND_REPORT_FAILURE */]:
        case types["_135" /* CORE_VERIFY_LOGIN_FAILURE */]:
        case types["_3" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE */]:
            var _action$payload = action.payload,
                statusText = _action$payload.statusText,
                code = _action$payload.code,
                message = _action$payload.message;

            var returnData = _extends({}, state, {
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            });
            return returnData;

        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/features/rooms/reducer.js


var rooms_reducer_initialState = [];
/* harmony default export */ var rooms_reducer = ({
  rooms: function rooms() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_118" /* CORE_SEARCH_ROOMS_REQUEST */]:
      case types["_76" /* CORE_LOAD_ROOMS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_119" /* CORE_SEARCH_ROOMS_SUCCESS */]:
      case types["_77" /* CORE_LOAD_ROOMS_SUCCESS */]:
        if (action.payload[0]) {
          return action.payload[0];
        } else return [];
      case types["_111" /* CORE_ROOMS_CLEAR */]:
        return [];
      default:
        return state;
    }
  },
  roomssuggest: function roomssuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_79" /* CORE_LOAD_ROOMS_SUGGEST_REQUEST */]:
        return {};
      case types["_80" /* CORE_LOAD_ROOMS_SUGGEST_SUCCESS */]:
        if (action.payload) {
          var payload = action.payload;
          return payload;
        } else return {};

      default:
        return state;
    }
  },
  roomsfirstsuggest: function roomsfirstsuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_74" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST */]:
        return {};
      case types["_75" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS */]:
        if (action.payload) {
          var payload = action.payload;
          return payload;
        } else return {};

      default:
        return state;
    }
  },
  roomInfo: function roomInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_70" /* CORE_LOAD_ROOMINFO_REQUEST */]:
      case types["_139" /* LOAD_ROOMINFO_REQUEST */]:
        return {};
      case types["_71" /* CORE_LOAD_ROOMINFO_SUCCESS */]:
      case types["_140" /* LOAD_ROOMINFO_SUCCESS */]:
        if (action.payload) {
          return action.payload;
        } else return {};
      default:
        return state;
    }
  },
  slots: function slots() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_91" /* CORE_LOAD_SLOTS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_92" /* CORE_LOAD_SLOTS_SUCCESS */]:
        if (action.payload[0]) {
          return action.payload;
        } else return [{}];

      default:
        return state;
    }
  },
  roomFormat: function roomFormat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_82" /* CORE_LOAD_ROOM_FORMAT_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_83" /* CORE_LOAD_ROOM_FORMAT_SUCCESS */]:
        if (action.payload) {
          return action.payload;
        } else return [];
      default:
        return state;
    }
  },
  roomType: function roomType() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_85" /* CORE_LOAD_ROOM_TYPE_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_86" /* CORE_LOAD_ROOM_TYPE_SUCCESS */]:
        if (action.payload) {
          return action.payload;
        } else return [];
      default:
        return state;
    }
  },
  formSuggest: function formSuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_113" /* CORE_SAVE_FORMSUGGEST */]:
        return action.form;
      default:
        return state;
    }
  },
  formSearchName: function formSearchName() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_112" /* CORE_SAVE_FORMSEARCHNAME */]:
        return action.form;
      case types["v" /* CORE_CLEAR_FORMSEARCHNAME */]:
        return {};
      default:
        return state;
    }
  },
  settings: function settings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_88" /* CORE_LOAD_SETTINGS_REQUEST */]:
        return {};
      case types["_89" /* CORE_LOAD_SETTINGS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/floors/reducer.js


var floors_reducer_initialState = [];
/* harmony default export */ var floors_reducer = ({
  floors: function floors() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floors_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_43" /* CORE_LOAD_FLOORS_REQUEST */]:
        return floors_reducer_initialState;

      case types["_44" /* CORE_LOAD_FLOORS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var floors = [];
          for (var i = 0; i < payload.length; i++) {
            floors.push({
              name: payload[i].name,
              buildingName: payload[i].buildingName,
              _id: payload[i]._id
            });
          }
          return floors;
        } else return [{}];

      default:
        return state;
    }
  },
  floorInfo: function floorInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floors_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_46" /* CORE_LOAD_FLOOR_INFO_REQUEST */]:
        return floors_reducer_initialState;

      case types["_47" /* CORE_LOAD_FLOOR_INFO_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var floorInfo = [];
          floorInfo.push({
            _id: payload._id,
            name: payload.name,
            buildingName: payload.buildingName
          });
          return floorInfo;
        } else return [{}];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/amenity/reducer.js


var amenity_reducer_initialState = [];
/* harmony default export */ var amenity_reducer = ({
  amenities: function amenities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_7" /* CORE_LOAD_AMENITIES_REQUEST */]:
        return amenity_reducer_initialState;
      case types["_8" /* CORE_LOAD_AMENITIES_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var amenities = [];
          for (var i = 0; i < payload.length; i++) {
            amenities.push({
              name: payload[i].name,
              maxRequest: payload[i].maxRequest,
              seq: payload[i].seq,
              _id: payload[i]._id
            });
          }
          return amenities;
        } else return [{}];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/user/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var user_reducer_initialState = [];
/* harmony default export */ var user_reducer = ({
  lastusers: function lastusers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_61" /* CORE_LOAD_LAST_USERS_REQUEST */]:
        return user_reducer_initialState;
      case types["_62" /* CORE_LOAD_LAST_USERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var lastuser = [];
          for (var i = 0; i < payload.length; i++) {
            lastuser.push({ value: payload[i]._id, key: i, text: payload[i].fullName, email: payload[i].email });
          }
          return lastuser;
        } else return [];

      default:
        return state;
    }
  },
  userInfo: function userInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_97" /* CORE_LOAD_USER_INFO_REQUEST */]:
      case types["_133" /* CORE_VERIFY_BYPASS_REQUEST */]:
      case types["_136" /* CORE_VERIFY_LOGIN_REQUEST */]:
        return {};
      case types["_137" /* CORE_VERIFY_LOGIN_SUCCESS */]:
      case types["_98" /* CORE_LOAD_USER_INFO_SUCCESS */]:
      case types["_134" /* CORE_VERIFY_BYPASS_SUCCESS */]:
      case types["_135" /* CORE_VERIFY_LOGIN_FAILURE */]:
        return action.payload;
      default:
        return {};
    }
  },
  auth: function auth() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["e" /* CORE_ACCEPT_TERM_REQUEST */]:
        return {};
      case types["f" /* CORE_ACCEPT_TERM_SUCCESS */]:
        return reducer__extends({}, state);
      default:
        return {};
    }
  },
  sendMailResetPassword: function sendMailResetPassword() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_127" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */]:
        return {};
      case types["_128" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */]:
        return {
          status: action.payload
        };
      default:
        return {};
    }
  },
  hasSendReport: function hasSendReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_130" /* CORE_SEND_REPORT_REQUEST */]:
        return [];
      case types["_131" /* CORE_SEND_REPORT_SUCCESS */]:
        return action.payload;
      default:
        return [];
    }
  },
  sendMail: function sendMail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_4" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST */]:
        return {};
      case types["_5" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS */]:
        if (typeof action.payload !== "undefined") return {
          status: action.payload
        };else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/users/reducer.js


var users_reducer_initialState = [];
/* harmony default export */ var users_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_94" /* CORE_LOAD_USERS_REQUEST */]:
        return users_reducer_initialState;
      case types["_95" /* CORE_LOAD_USERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var user = [];
          for (var i = 0; i < payload.length; i++) {
            user.push({ value: payload[i]._id, key: i, text: payload[i].fullName, email: payload[i].email });
          }
          return user;
        } else return [{ value: 0, key: 0, text: 0 }];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/events/reducer.js


var events_reducer_initialState = [];
/* harmony default export */ var events_reducer = ({
  events: function events() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      // case CORE_CREATE_EVENT_REQUEST:
      // case CORE_DELETE_EVENT_REQUEST:
      // case CORE_DELETE_EVENT_SUCCESS:
      //   return initialState
      // case CORE_CREATE_EVENT_SUCCESS:
      //   return action.payload
      case types["_31" /* CORE_LOAD_EVENTINFO_REQUEST */]:
        return {};
      case types["_32" /* CORE_LOAD_EVENTINFO_SUCCESS */]:
        if (action.payload[0]) {
          var payLoad = action.payload[0];
          return payLoad;
        } else return {};
      // case CORE_EDIT_EVENT_REQUEST:
      //   return {}
      // case CORE_EDIT_EVENT_SUCCESS:
      //   return action.payload
      default:
        return state;
    }
  },
  logTitle: function logTitle() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_40" /* CORE_LOAD_EVENT_LOG_TITLE_REQUEST */]:
        return events_reducer_initialState;
      case types["_41" /* CORE_LOAD_EVENT_LOG_TITLE_SUCCESS */]:
        if (action.payload[0]) {
          var payLoad = action.payload[0];
          return payLoad;
        } else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/mybookings/reducer.js


var mybookings_reducer_initialState = [];
/* harmony default export */ var mybookings_reducer = ({
  eventIncoming: function eventIncoming() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mybookings_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_25" /* CORE_LOAD_EVENTINCOMING_REQUEST */]:
        return mybookings_reducer_initialState;
      case types["_26" /* CORE_LOAD_EVENTINCOMING_SUCCESS */]:
        if (typeof action.payload[0] !== "undefined") return action.payload[0];else return [{}];

      default:
        return state;
    }
  },
  eventHistory: function eventHistory() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mybookings_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_22" /* CORE_LOAD_EVENTHISTORY_REQUEST */]:
        return mybookings_reducer_initialState;
      case types["_23" /* CORE_LOAD_EVENTHISTORY_SUCCESS */]:
        if (typeof action.payload[0] !== "undefined") return action.payload[0];else return [{}];
      default:
        return state;
    }
  },
  eventCalendar: function eventCalendar() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mybookings_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_19" /* CORE_LOAD_EVENTCALENDAR_REQUEST */]:
        return mybookings_reducer_initialState;
      case types["_20" /* CORE_LOAD_EVENTCALENDAR_SUCCESS */]:
        if (typeof action.payload[0] !== "undefined") return action.payload[0];else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/amenityandservice/reducer.js


var amenityandservice_reducer_initialState = [];
/* harmony default export */ var amenityandservice_reducer = ({
  amenityActive: function amenityActive() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_10" /* CORE_LOAD_AMENITYACTIVE_REQUEST */]:
      case types["_121" /* CORE_SENDAMENITY_REQUEST */]:
      case types["P" /* CORE_DONEAMENITY_REQUEST */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return state;
      case types["_11" /* CORE_LOAD_AMENITYACTIVE_SUCCESS */]:
      case types["_122" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["i" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["Q" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  amenityPast: function amenityPast() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_16" /* CORE_LOAD_AMENITYPAST_REQUEST */]:
      case types["_121" /* CORE_SENDAMENITY_REQUEST */]:
      case types["P" /* CORE_DONEAMENITY_REQUEST */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return state;
      case types["_17" /* CORE_LOAD_AMENITYPAST_SUCCESS */]:
      case types["_122" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["i" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["Q" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  amenityNext: function amenityNext() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_13" /* CORE_LOAD_AMENITYNEXT_REQUEST */]:
      case types["_121" /* CORE_SENDAMENITY_REQUEST */]:
      case types["P" /* CORE_DONEAMENITY_REQUEST */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return {};
      case types["_14" /* CORE_LOAD_AMENITYNEXT_SUCCESS */]:
      case types["_122" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["i" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["Q" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodActive: function foodActive() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_49" /* CORE_LOAD_FOODACTIVE_REQUEST */]:
      case types["_124" /* CORE_SENDFOOD_REQUEST */]:
      case types["S" /* CORE_DONEFOOD_REQUEST */]:
      case types["k" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_50" /* CORE_LOAD_FOODACTIVE_SUCCESS */]:
      case types["_125" /* CORE_SENDFOOD_SUCCESS */]:
      case types["T" /* CORE_DONEFOOD_SUCCESS */]:
      case types["l" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodPast: function foodPast() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_55" /* CORE_LOAD_FOODPAST_REQUEST */]:
      case types["_124" /* CORE_SENDFOOD_REQUEST */]:
      case types["S" /* CORE_DONEFOOD_REQUEST */]:
      case types["k" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_56" /* CORE_LOAD_FOODPAST_SUCCESS */]:
      case types["_125" /* CORE_SENDFOOD_SUCCESS */]:
      case types["T" /* CORE_DONEFOOD_SUCCESS */]:
      case types["l" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodNext: function foodNext() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_52" /* CORE_LOAD_FOODNEXT_REQUEST */]:
      case types["_124" /* CORE_SENDFOOD_REQUEST */]:
      case types["S" /* CORE_DONEFOOD_REQUEST */]:
      case types["k" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return {};
      case types["_53" /* CORE_LOAD_FOODNEXT_SUCCESS */]:
      case types["_125" /* CORE_SENDFOOD_SUCCESS */]:
      case types["T" /* CORE_DONEFOOD_SUCCESS */]:
      case types["l" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderInfoService: function orderInfoService() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_28" /* CORE_LOAD_EVENTINFOSERVICE_REQUEST */]:
        return {};
      case types["_29" /* CORE_LOAD_EVENTINFOSERVICE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderAmenityList: function orderAmenityList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_34" /* CORE_LOAD_EVENTSERVICEAMENITY_REQUEST */]:
        return [];
      case types["_35" /* CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderFbsList: function orderFbsList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_37" /* CORE_LOAD_EVENTSERVICEFBS_REQUEST */]:
        return [];
      case types["_38" /* CORE_LOAD_EVENTSERVICEFBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderLogFbsList: function orderLogFbsList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_103" /* CORE_ORDER_LOG_FOOD_REQUEST */]:
        return [];
      case types["_104" /* CORE_ORDER_LOG_FOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderLogAmenityList: function orderLogAmenityList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_100" /* CORE_ORDER_LOG_AMENITY_REQUEST */]:
        return [];
      case types["_101" /* CORE_ORDER_LOG_AMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/orders/reducer.js
var orders_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var orders_reducer_initialState = [];

/* harmony default export */ var orders_reducer = ({
  orders: function orders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : orders_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_64" /* CORE_LOAD_ORDERS_REQUEST */]:
        return orders_reducer_initialState;
      case types["_65" /* CORE_LOAD_ORDERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var orders = [];
          for (var i = 1; i <= payload.length; i++) {
            orders.push(orders_reducer__extends({ no: i }, payload[i - 1]));
          }
          return orders;
        } else return [];

      default:
        return state;
    }
  },
  orderInfo: function orderInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_67" /* CORE_LOAD_ORDER_INFO_REQUEST */]:
        return {};
      case types["_68" /* CORE_LOAD_ORDER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/foods/reducer.js


var foods_reducer_initialState = [];
/* harmony default export */ var foods_reducer = ({
  foods: function foods() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : foods_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_58" /* CORE_LOAD_FOODS_REQUEST */]:
        return foods_reducer_initialState;
      case types["_59" /* CORE_LOAD_FOODS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var amenities = [];
          for (var i = 0; i < payload.length; i++) {
            // amenities.push({
            //   name: payload[i].name,
            //   _id: payload[i]._id
            // })
            amenities.push(payload[i]);
          }
          return amenities;
        } else return [{}];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/qrcode/reducer.js


var qrcode_reducer_initialState = [];
/* harmony default export */ var qrcode_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrcode_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_94" /* CORE_LOAD_USERS_REQUEST */]:
        return qrcode_reducer_initialState;
      case types["_95" /* CORE_LOAD_USERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var user = [];
          for (var i = 0; i < payload.length; i++) {
            user.push({ value: payload[i]._id, key: i, text: payload[i].fullName });
          }
          return user;
        } else return [{ value: 0, key: 0, text: 0 }];

      default:
        return state;
    }
  },
  userInfo: function userInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrcode_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_97" /* CORE_LOAD_USER_INFO_REQUEST */]:
        return {};
      case types["_98" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return {};
    }
  },
  qrcode: function qrcode() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrcode_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_115" /* CORE_SCANQR_REQUEST */]:
        return {};
      case types["_116" /* CORE_SCANQR_SUCCESS */]:
        return action.payload;
      case types["_114" /* CORE_SCANQR_FAILURE */]:
        return action.payload;
      default:
        return {};
    }
  },
  checkCanBook: function checkCanBook() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
      case types["q" /* CORE_CHECKCANBOOK_REQUEST */]:
        return state;
      case types["r" /* CORE_CHECKCANBOOK_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/reducers.js



// import authReducer from 'Features/user/reducer'













/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["c" /* reducer */],
    notifications: Object(lib["reducer"])(),
    auth: user_reducer.auth,
    ui: reducer,
    rooms: rooms_reducer.rooms,
    roomssuggest: rooms_reducer.roomssuggest,
    roomsfirstsuggest: rooms_reducer.roomsfirstsuggest,
    slots: rooms_reducer.slots,
    floors: floors_reducer.floors,
    roomType: rooms_reducer.roomType,
    roomFormat: rooms_reducer.roomFormat,
    roomInfo: rooms_reducer.roomInfo,
    formSuggest: rooms_reducer.formSuggest,
    formSearchName: rooms_reducer.formSearchName,
    settings: rooms_reducer.settings,
    floorInfo: floors_reducer.floorInfo,
    amenities: amenity_reducer.amenities,
    users: users_reducer.users,
    hasSendReport: user_reducer.hasSendReport,
    lastusers: user_reducer.lastusers,
    userInfo: user_reducer.userInfo,
    eventinfo: events_reducer.events,
    logTitle: events_reducer.logTitle,
    eventIncoming: mybookings_reducer.eventIncoming,
    eventHistory: mybookings_reducer.eventHistory,
    eventCalendar: mybookings_reducer.eventCalendar,
    amenityActive: amenityandservice_reducer.amenityActive,
    amenityPast: amenityandservice_reducer.amenityPast,
    amenityNext: amenityandservice_reducer.amenityNext,
    foodActive: amenityandservice_reducer.foodActive,
    foodPast: amenityandservice_reducer.foodPast,
    foodNext: amenityandservice_reducer.foodNext,
    orderLogAmenityList: amenityandservice_reducer.orderLogAmenityList,
    orderLogFbsList: amenityandservice_reducer.orderLogFbsList,
    orders: orders_reducer.orders,
    orderInfo: orders_reducer.orderInfo,
    foods: foods_reducer.foods,
    qrcode: qrcode_reducer.qrcode,
    sendMailResetPassword: user_reducer.sendMailResetPassword,
    sendMail: user_reducer.sendMail,
    orderInfoService: amenityandservice_reducer.orderInfoService,
    orderAmenityList: amenityandservice_reducer.orderAmenityList,
    orderFbsList: amenityandservice_reducer.orderFbsList,
    checkCanBook: qrcode_reducer.checkCanBook
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 955:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 956:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 963:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 990:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[677]);


// WEBPACK FOOTER //
// app.cf22f20fe5dbd64b63f4.js